(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds"]) return;
  try {
    
 
  const SVG_VERSION = "20260825C";
  var stikrd_pid = getCookie("stikrd_pid");
  var stikrd_pn = getCookie("stikrd_pn");
  var stikrd_pt = getCookie("stikrd_pt");
  var stikrd_vid = getCookie("stikrd_vid"); 
  var qs_varid = ""; 
  var qs_cachebuster = "20260825C"
  var qs_store = "";
  var hide_metallic_msg = false;
  var stikrdHandle = "";
  
  var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');
  
          if (sParameterName[0] === sParam) {
              return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
      return false;
  };

  console.log("PID:" + stikrd_pid + ", title: " + stikrd_pt + ", name: " + stikrd_pn);
  console.log("Original IMAGE: " + svgImageFile);

  qs_varid = getUrlParameter("varid");
  qs_cachebuster = getUrlParameter("cachebuster");
  console.log("ORIG ID: " + $('input[name="id"]').val());
  console.log("QS VAR ID: " + qs_varid);
  if(qs_varid.length > 0) {
    console.log("QS update the form value with 3rd party variant Id:" + qs_varid);
    $('input[name="id"]').val(qs_varid);
  }
  else
    console.log("QS DONT update the form value with 3rd party variant Id:" + qs_varid);
    

  // if cookie values not present from a microsite landing page hit, grab QS values
  if(stikrd_pt == null || stikrd_pt.length <= 0) {
    stikrd_pt = getUrlParameter("pt");
    console.log("QS microsite? title: " + stikrd_pt);
  }






  if(stikrd_vid == null || stikrd_vid.length <= 0) {
    stikrd_vid = getUrlParameter("vid");
    console.log("QS microsite? vid:" + stikrd_vid);
  }

  // microsite override
  qs_store = getUrlParameter("store");
  console.log("QS store: " + qs_store);
  if(qs_store.length > 0) {
    console.log("QS store has a value:" + qs_store);
    qs_ptitle = getUrlParameter("pt");
    console.log("QS PT: " + qs_ptitle);
    if(qs_ptitle.length > 0) {
      console.log("QS PT has a value, Update the PT OVERRIDE:" + qs_ptitle);
      stikrd_pt = qs_ptitle;
    }
    else
      console.log("QS no PT:" + qs_ptitle);  
  }
  else {
    console.log("QS no store:" + qs_store);
    $("#product-form").attr("action", "/cart/add");
  }
  
  if(stikrd_pt != null && stikrd_pt.length > 0) {

    // check for store and MAP the 3rd-party product number to the decal 
    if(qs_store.length > 0) {
      var qs_pn = getUrlParameter("pn");
  
      console.log("MAP pn to internal pn: " + qs_pn + ", existing stikrd_pt: " + stikrd_pt);

      stikrdHandle = collectiveMap1[qs_pn];
      if (typeof stikrdHandle === 'string') {
        stikrdHandle = stikrdHandle.toUpperCase().replaceAll("-", "_");  
      } else {
        stikrdHandle = "";
      }
      console.log("MAP pn to internal pn: " + qs_pn + ", MAP to: " + stikrdHandle);

      if(stikrdHandle.length > 0)
        svgImageFile = "files/" + stikrdHandle.replaceAll(".", "").replaceAll("+", "_").toUpperCase() + "_SOLID.svg";
      else
        svgImageFile = "files/" + stikrd_pt.replaceAll(".", "").replaceAll("+", "_").toUpperCase() + "_SOLID.svg";
      console.log("New IMAGE name: " + svgImageFile + ", store: " + qs_store);

    }
    else {
      // no store handle but get the correct handle
      console.log("no store or MAP, use meta IMAGE name: " + svgImageFile + ", store: " + qs_store);
    }
    

    productTitle = stikrd_pt.replaceAll("+", " ").replaceAll("\"", ""); //replace: '"', '\"' }}";


    
    var vidElement = $('input[name="id"]');
    // STORE...override for add to cart on the way back
    if(qs_store.length > 0) {
      var qs_vid = getUrlParameter("vid");

      var vid = collectiveMapVid1[qs_vid];
      if (typeof vid === 'string') {
        console.log("QS store has a value, set VID via mapped value:" + qs_store + ", vid:" + vid);
        vidElement.val(vid);
      } else {
        console.log("QS store has a value, set VID via qs:" + qs_store + ", vid:" + vid + ", qsvid: " + qs_vid);
        vidElement.val(qs_vid);
      }      
  
    }
    else {  
      if(stikrd_vid != null && stikrd_vid.length > 0) {
        console.log("Stikrd vid:" + stikrd_vid);
        vidElement.val(stikrd_vid);
      }
    }
    console.log("pn from server-side?: { { pn } }");
    console.log("Root: " + window.Shopify.routes.root);
  }
  else
    console.log("Old IMAGE: " + svgImageFile);
    
  if(stikrd_pn == stikrd_pn_q)
    console.log("EQUAL Name: " + stikrd_pn);
  else  {
    console.log("NOT EQUAL Name: " + stikrd_pn);
    // set up the files
  }
  
var nowStr = $.now();
  
const designId = "STIKRD-" + nowStr;
console.log("secs: " + designId);
$("#design-id").val(designId);
  
var coll = document.getElementsByClassName("collapsible");
var i;
var colorPalette;
var Layer;
var onObject;
var colorPaletteName;
var masterColorHex = "";
var masterColorName = "";
var masterColorList = [];  
var masterColorNameList = [];  
var masterGradientColorList = [];  
var masterGradientColorNameList = [];  
var masterPatternColorList = [];  
var masterPatternColorNameList = [];  
var SVGimage;
var defaultColor = "typeButtonCherry";
var isSolid = true;
var isGloss = true;
var maxHeightColl = 264;
var welcomeText = "Select a Pantone or Brand color from the selections on the left.<br><br>Hover over the stickers to see highlighted sections and click to swap colors.";  
var defaultPatternSVG = "NATURE_PALMS_MIAMI.svg";
var patternLeftOffset = -325;
var patternTopOffset = -325;
var patternDefaultFactor = 2;
  
let zoomLevel = 1;
const zoomStep = 0.1;
const minZoom = 0.8;
const maxZoom = 3;

  
function collapseColors(obj) {
  console.log("click, in collapseColors with: " + obj.id + ", TOGGLE it");
  obj.classList.toggle("active");
  var content = obj.nextElementSibling;
  if (content.style.maxHeight){
    content.style.maxHeight = null;
    console.log("click 11: " + content.style.maxHeight);
  } else {
    if(maxHeightColl < content.scrollHeight)
      content.style.maxHeight = maxHeightColl + "px";
    else
      content.style.maxHeight = content.scrollHeight + "px";
    console.log("click 22: " + content.style.maxHeight);
  } 
}

function collapseColorsBrand() {
  var brandColorDiv = $("#brand-colors-button");
  console.log("click, ccBrand: " + brandColorDiv);
  collapseColors(brandColorDiv);
}
  
$('#pantone-colors-button').click(function (e) {
  console.log("pan colors btn click" + e);
  collapseColors(this);
  var brandColorDivElem = document.getElementById("brand-colors-button");
  console.log(brandColorDivElem);
  collapseColors(brandColorDivElem);
});
  
$('#brand-colors-button').click(function (e) {
  console.log("brand colors btn click" + e);
  collapseColors(this);
  var pantoneColorDivElem = document.getElementById("pantone-colors-button");
  console.log(pantoneColorDivElem);
  collapseColors(pantoneColorDivElem);
});
  
$('#patterns-button').click(function (e) {
  console.log("patterns btn click" + e);
  this.classList.toggle("active");
  var content = this.nextElementSibling;
  if (content.style.maxHeight){
    console.log("click pattern 1: " + content.style.maxHeight);
    content.style.maxHeight = null;
    console.log("click pattern 1: " + content.style.maxHeight);
  } else {
    console.log("click pattern 2: " + content.style.maxHeight);
    if(maxHeightColl < content.scrollHeight)
      content.style.maxHeight = maxHeightColl + "px";
    else
      content.style.maxHeight = content.scrollHeight + "px";
    console.log("click pattern 2: " + content.style.maxHeight);
  } 
});
  
function setMainView(currentTab, isSolid) {
  console.log("set main view: " + currentTab + ", " + isSolid);
  
  if(currentTab == 1) {
    $('#pattern2').hide();
    $('#gradient2').hide();
    $('#gradient2-outline').hide();
    $('#pattern2-outline').hide();
    $('#panel-2').hide();
    $('#panel-3').hide();  
    $('#panel-1').show();
    if(isSolid) {
      $('#home2').show();
      $('#home2-outline').hide();
    }
    else {
      $('#home2').hide();
      $('#home2-outline').show();
    }
  }
  if(currentTab == 2) {
    $('#pattern2').hide();
    $('#home2').hide();
    $('#home2-outline').hide();
    $('#pattern2-outline').hide();
    $('#panel-1').hide();
    $('#panel-3').hide();  
    $('#panel-2').show();
    if(isSolid) {
      $('#gradient2').show();
      $('#gradient2-outline').hide();
    }
    else {
      $('#gradient2').hide();
      $('#gradient2-outline').show();
    }
  }
  if(currentTab == 3) {
    $('#gradient2').hide();
    $('#home2').hide();
    $('#gradient2-outline').hide();
    $('#home2-outline').hide();
    $('#panel-2').hide();
    $('#panel-1').hide();  
    $('#panel-3').show();
    if(isSolid) { 
      $('#pattern2').show();
      $('#pattern2-outline').hide();
    }
    else {
      $('#pattern2').hide();
      $('#pattern2-outline').show();
    }
  }
}
  
function addColorButtonToSection(color, sectionId) {

  var tempKey = color[1];
  let key = tempKey.replaceAll(" ", "-");        
  let tempDiv = document.createElement("div");
  let value = color[2];
  //let percentage = color[4];

  tempDiv.setAttribute("id", "typeButton" + key);        
  tempDiv.setAttribute("style", "display: flex; cursor: pointer;");        

  document.getElementById(sectionId).appendChild(tempDiv); 
        
  let colorDiv = document.createElement("div");
  colorDiv.setAttribute("class", "swatch ds-center");
  colorDiv.setAttribute("id", key);
  colorDiv.setAttribute("data-color-hex", value.toLowerCase());
  colorDiv.setAttribute("style", "background-color: #" + value);

  let name = document.createElement("div");
  
  var percentMatch = color[4];
  var material = color[5];
  if(percentMatch == "")
    percentMatch = "100";
  let percentSpan = document.createElement("span");
  percentSpan.setAttribute("style", "font-size: 10px; vertical-align: middle;");
  percentSpan.innerText = " (" + percentMatch + "%)" + (material == "met" ? " M" : "");

  name.innerText = key.replaceAll("-", " ");
  name.setAttribute("id", "colorName-" +  key);
  name.setAttribute("style", "font-size: 12px; margin: 7px 4px 0px 3px;");
  name.appendChild(percentSpan);    
  
  tempDiv.appendChild(colorDiv);
  tempDiv.appendChild(name);
  
  tempDiv.addEventListener("click", () => {
      console.log("color mousedown: " + key + ", val: " + value);
      colorPalette = "#" + value;	// saves color to be used when clicking on a group
      colorPaletteName = tempKey;     
      console.log("tempkey: " + tempKey);

      // clear all actives first then set active
      //$('[id^="colorName"]').css("margin", "4px 4px");
      $('[id^="colorName"]').css("font-weight", "normal");    
    
      // set selected border or indicate selected
      var colorActive = document.getElementById("colorName-" +  key);
      colorActive.setAttribute("style", "font-size: 12px; margin: 7px 4px 0px 3px; font-weight: bold");
                      
      updateColors(key, value);

      // alert
      if(material == "met" && !hide_metallic_msg) {
        $('#material-modal').modal('show');
      }
  }, false);
}   

  
var pathStr = "../cdn/shop/files/";
var imageName = "";
  
function createPatternButtons() {

  var htmlPattern = "";
  var key = "key";
  var value = "val";
  console.log("create patterns...");
      
  for(var i = 0; i < patternInfo.length; i++) {
    var pattern = patternInfo[i];

    if(pattern[1].indexOf(".svg") < 0)
      continue;
    console.log("pattern info: " + i + ", name:" + pattern[0] + ", image: " + pattern[1] + ", idx: " + pattern[1].indexOf("USAFlag"));
    htmlPattern = htmlPattern + "<div style='display: flex' data-pidx='" + i + "' id='patternImage" + i + "'><div id='pid" + i + "' class='swatch swatch-pattern'><img class='pattern-img' src='" + pathStr + pattern[1] + "' ></div><div class='mt-3 ml-1' id='patternName" + i + "'>" + pattern[0] + "</div></div>";    
  }
  $("#patternHolderMain").append(htmlPattern); 
  
  // patternImage click handlers
  $('[id^="patternImage"]').each(function(index, element) {
    let pidx = element.dataset.pidx;
    element.addEventListener("click", () => {
 
      $("#stikrd-pattern-range").val(1);
      $("#stikrd-pattern-rotate").val(0);
      $("#pattern-stretch-value").text("1");
      $("#pattern-rotate-value").text("0");

      // clear color arrays
      masterPatternColorList = [];
      masterPatternColorNameList = [];
      
      var pattern = patternInfo[pidx];
      console.log("Pattern mousedown: " + pattern[0]);
      var value = pattern[1];
      var key = pattern[0];
        
      // clear all actives first then set active
      $('[id^="patternName"]').css("font-weight", "normal");    

      // set selected border or indicate selected
      var patternActive = $("#patternName" + index);
      console.log("pattern mousedown!!!: " + patternActive.attr("id"));
      patternActive.attr("style", "font-weight: bold");

      updatePattern(key, value);

      // apply pattern on click
      fillPattern(canvasPattern, isSolid);
      fillPattern(canvasPatternOutline, isSolid);      
    }, false);
  }); 
}
  
// return active tab number
function getActiveTab() {
  // nav-link
  // home, gradient, pattern
  if($("#home-tab").hasClass("active")) {
    console.log("2home active: " + $("#home-tab.active"));
    return 1;
  }
  else if($("#gradient-tab").hasClass("active")) {
    console.log("2grad active: " + $("#gradient-tab.active"));
    return 2;
    
  }
  else if($("#pattern-tab").hasClass("active")){
    console.log("3pattern active: " + $("#pattern-tab.active"));
    return 3; 
  }
}  


function getActiveCanvas() {
  console.log("get active canvas...");
  
  // find active canvas and return it
  let activeTab = getActiveTab();
  
  if(activeTab == 1) {
    if(isSolid) {
  console.log("get active canvas1 solid...");
      return canvas;
    }
    else {
  console.log("get active canvas1 outline...");
      return canvasOutline;
    }
  } 
  else if(activeTab == 2) {
    if(isSolid)
      return canvasGradient;  
    else
      return canvasGradientOutline;
  }
  else if(activeTab == 3) {
    if(isSolid)
      return canvasPattern;
    else
      return canvasPatternOutline;
  }
}  

function resetZoom() {
  console.log("zoom reset");
  let canvas = getActiveCanvas();
  zoomLevel = 1;
  canvas.setZoom(zoomLevel);
  canvas.setViewportTransform([zoomLevel, 0, 0, zoomLevel, 0, 0]);
}
  
// #pantone
function createColorButtons() {
  
    for(var i = 0; i < colorInfo.length; i++) {
      var color = colorInfo[i];
      
      if(color[0] == "PANTONE") {

        if(debug && 1 == 0) {
          for(var j = 0; j < color.length; j++) {
            console.log("color[" + i + "] = " + color[j]);
            console.log("color[" + i + "] = " + color[1]);
          }        
        }
        addColorButtonToSection(color, "pantoneHolderMain");      
      }
    }

    // build color brands ---------------------------
    var currentBrand = "";
    var htmlColors = "";
    var firstColor = true;
  
    for(var i = 0; i < colorInfo.length; i++) {
      var color = colorInfo[i];
      var colorGroup = color[0];
      
      // group by name not PANTONE
      if(colorGroup != "PANTONE") {
            if(currentBrand != colorGroup) {
              currentBrand = colorGroup;

              if(!firstColor)
                htmlColors = htmlColors + "</ul></li>";         
                
              htmlColors = htmlColors + "<ul id='stikrdUL'><li><span class='caret'>" + currentBrand + "</span><ul class='nested nested-content nested-brand'>";  
              firstColor = false;
            }
            var tempKey = color[1];
            var percentMatch = color[4];
            var material = color[5];
            if(percentMatch == "")
              percentMatch = "100";
        
            let key = tempKey.replaceAll(" ", "-");        
            let value = color[2];
          
            htmlColors = htmlColors + "<li class='nothingcache3'><div style='display: flex; cursor: pointer;' data-mat='" + material + "' data-hex='" + value + "' id='typeButtonBrand" + key + "'>";
        
            htmlColors = htmlColors + "<div class='swatch ds-center' style='background-color: #" + value + "' id='" + key.replaceAll(" ", "-") + "'></div>";
            htmlColors = htmlColors + "<div style='font-size: 12px; margin: 7px 4px 0px 3px;' id='colorName-" + key + "'>" + key.replaceAll("-", " ") + " <span style='font-size: 10px'>(" + percentMatch + "%)" + (material == "met" ? " M" : "") + "</span></div> ";        
            htmlColors = htmlColors + "</div></li>";        
      }
    }
  
    // close UL
    htmlColors = htmlColors + "</li></ul><br>&nbsp;<br>";  
    $("#brandHolderMain").append(htmlColors); 

    // typeButtonBrand click handlers
    $('[id^="typeButtonBrand"]').each(function(index, element) {
      element.addEventListener("click", () => {
      
          console.log("color BRAND mousedown: " + $(this).children().first().attr("id"));
          var value = $(this).data("hex");
          var material = $(this).data("mat");
          var key = $(this).children().first().attr("id");
          var tempKey = key.replaceAll("-", " ");
        
          console.log("color mousedown: " + key);
          colorPalette = "#" + value;	//saves color to be used when clicking on a group
          colorPaletteName = tempKey;     
    
          // clear all actives first then set active
          $('[id^="colorName"]').css("margin", "7px 4px 0px 3px");
          $('[id^="colorName"]').css("font-weight", "normal");    
        
          // set selected border or indicate selected
          var colorActive = document.getElementById("colorName-" +  key);
          colorActive.setAttribute("style", "font-size: 12px; margin: 7px 4px 0px 3px; font-weight: bold");
                          
          updateColors(key, value);

          // alert
          if(material == "met" && !hide_metallic_msg) {
            $('#material-modal').modal('show');
          }
      }, false);
    }); 

    $("#reset-btn").on( "click", function() {
      console.log("reset: tab: , solid? " + isSolid + ", actvie tab:" + getActiveTab());
      if(getActiveTab() == 1) {
        let usedColors = $("#used-colors");
        //usedColors.html(welcomeText);
        
        //clear color array
        masterColorList = [];
        masterColorNameList = [];
        
        usedColorsList.length = 0;
        canvas.clear();
        // call setup
        initColorSwap();

        canvasOutline.clear();
        // call setup
        initColorSwapOutline();
      }
      
      if(getActiveTab() == 2) {
        $("#gradient-checkbox-3").prop("checked", false);
        $("#gradient-checkbox-4").prop("checked", false);
        $("#gradient-color-1").css("background-color","#FFFFFF");
        $("#gradient-color-1").data("hex-color", "#FFFFFF");
        $("#gradient-color-1").data("name-color", "White");
        $("#gradient-color-2").css("background-color","#888B8D");
        $("#gradient-color-2").data("hex-color", "#888B8D");
        $("#gradient-color-2").data("name-color", "Black");
        $("#stikrd-range").val(50);
        $("#gradient-directions").val(1);
        $("#gradient-strength-value").html("50");
        
          canvasGradient.clear();
          // call setup
          initGradient();
          canvasGradientOutline.clear();
          // call setup
          initGradientOutline();           
      }

      if(getActiveTab() == 3) {
        console.log("reset pattern!");
        
        //clear color array
        masterPatternColorList = [];
        masterPatternColorNameList = [];
        
        // function to reset pattern
        $("#stikrd-pattern-range").val(1);
        $("#stikrd-pattern-rotate").val(0);
        $("#pattern-stretch-value").text("1");
        $("#pattern-rotate-value").text("0");
        
        //updatePattern(patternInfo[0][0], patternInfo[0][1]);
        console.log("click the first pattern: " + $('#pid0').length);
        $('#pid0').first().click();         
      }
    });
  
    $("#gradient-btn").on( "click", function() {
      if(isSolid)
        fillGradient(canvasGradient, isSolid);
      else
        fillGradient(canvasGradientOutline, isSolid);
      console.log("gradient and outline btn click, solid? " + isSolid);
    });
    
    $("#pattern-btn").on( "click", function() {
      if(isSolid)
        fillPattern(canvasPattern, isSolid);
      else
        fillPattern(canvasPatternOutline, isSolid);
      console.log("pattern and outline btn click, solid? " + isSolid);
    });
  
    $("#solidOutlineSwitch").on( "click", function() {
      isSolid = !isSolid;
      console.log("switch solid-outline btn click: solid> " + isSolid);
          setMainView(activeTab, isSolid);
    });

    $("#finishSwitch").on( "click", function() {
      isGloss = !isGloss;
      console.log("switch finish btn click: solid> " + isGloss);
    });
  
    $("#gradient-color-1").on( "click", function() {
      $(this).css("background-color", colorPalette);
      $(this).data("hex-color", colorPalette);
      $(this).data("name-color", colorPaletteName);
      console.log("grad color 11 update to: " + colorPalette);
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
    });

    $("#gradient-color-2").on( "click", function() {
      $(this).css("background-color", colorPalette);
      $(this).data("hex-color", colorPalette);
      $(this).data("name-color", colorPaletteName);
      console.log("grad color 2 update to: " + colorPalette);
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
    });
  
    $("#gradient-color-3").on( "click", function() {
      $(this).css("background-color", colorPalette);
      $(this).data("hex-color", colorPalette);
      $(this).data("name-color", colorPaletteName);
      $("#gradient-checkbox-3").prop('checked', true);
      console.log("grad color 3 update to: " + colorPalette);
      
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      console.log("gradient color 3, solid? " + isSolid);
    });

    $("#gradient-checkbox-3").on( "click", function() {
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      console.log("gradient checkbox color 3, solid? " + isSolid + this.checked);
    });
                              
    $("#gradient-color-4").on( "click", function() {
      $(this).css("background-color", colorPalette);
      $(this).data("hex-color", colorPalette);
      $(this).data("name-color", colorPaletteName);
      $("#gradient-checkbox-4").prop('checked', true);
      console.log("grad color 4 update to: " + colorPalette);

      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      console.log("gradient color 4, solid? " + isSolid);
    });

    $("#gradient-checkbox-4").on( "click", function() {
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      console.log("gradient checkbox color 4, solid? " + isSolid + this.checked);
    });
  
    $("#gradient-directions").on( "change", function() {
      fillGradient(canvasGradient, isSolid);
      fillGradient(canvasGradientOutline, isSolid);
      console.log("gradient directions listbox dropdown, solid? " + isSolid);
    });
  
    $(".pattern-swatch-color").on( "click", function() {
      alert('color');
      console.log("pattern swatch color");
    });
}

function updateAllObjectColors(canvas, newColor, newColorName) {
    
    console.log("updateAllObjectColors: color: " + newColor + ", canvs id: " + canvas.id);
    console.log("ct objs: ", canvas.getObjects());

    canvas.getObjects().forEach(function (obj) {
        console.log("updateAllObjectColors: obj.id: " + obj.id);
        if(obj.id != null && obj.id.toLowerCase().startsWith("layer")) {
          console.log("fill? : " + obj.type + ", id: "+ obj.id + ", fill: " + obj.fill + ", name: " + obj.colorName);    
          if (obj.set) {
              obj.fire('mousedown', {
                  e: null,               // optional: native mouse event
                  target: obj
              });
          } 
        }
    });

    canvas.requestRenderAll();
}
  
function getObjectsFromCanvas(canvas) {
  console.log("getObjectsFromCanvas...");
  var objects = [];
  canvas.getObjects().forEach(function (obj) {
    if(obj != null && obj.type == "path" && ((obj.id.startsWith("LAYER_") && isSolid) || (obj.id.startsWith("TOP_") && !isSolid))) {
      console.log("get obj from canvas LAYER and TOP: " + obj.id + ", type: " + obj.type);
      objects.push(obj);
    }
  });
  return objects;                              
} 
 
function getObjectById(canvas, objId) {
  var activeObject = null;
  canvas.getObjects().forEach(function(obj) {
      if(obj.id === objId) {    
        activeObject = obj;
        console.log("get object: activeObj found!" + obj.id);
      }
  })
  return activeObject;
}

var originalScaleX = 1;
var originalScaleY = 1;
var patterObjects = null;
var patterOutlineObjects = null;
  
function swapPatternColor(currentColor) {
  
  console.log("swapPatternColor: currentColor: " + currentColor + ", colorPalette: " + colorPalette);
  
  // SWAP COLORS USED also

  
  canvasPattern.getObjects().forEach(function (obj) {  

    console.log("swapPatternColor: " + obj.id + ", fill:" + obj.fill + ", type: " + obj.type + ", currentColor: " + currentColor);
    if(obj.type == "group") {
      obj._objects.forEach(function(object) {
        console.log("object: " + object.id + ", fill: " + object.fill);
        if(object.id != undefined && object.id.toLowerCase().startsWith("layer") && currentColor == object.fill) {
          console.log("FOUND!");      
          object.set('fill', colorPalette);
          swapMasterPatternColorsUsed(currentColor);
        }
      });
    }               
    canvasPattern.requestRenderAll();
  });

  canvasPatternOutline.getObjects().forEach(function (obj) {
    
    console.log("swapPatternColor: " + obj.id + ", fill:" + obj.fill + ", type: " + obj.type + ", currentColor: " + currentColor);
    if(obj.type == "group") {
      obj._objects.forEach(function(object) {
        console.log("object: " + object.id + ", fill: " + object.fill);
        if(currentColor == object.fill && object.id.toLowerCase().startsWith("layer")) {
          console.log("FOUND!");      
          object.set('fill', colorPalette);
          //TODO2
        }
      });
    }               
    canvasPatternOutline.requestRenderAll();
  });
} 

function showPatternColors(layers) {

  patternColorsList = [];
  
  let patternColors = $("#pattern-colors");
  var fillColor = "";
  $('.pattern-colors-list').remove();
  
  layers.forEach(function(obj) {
    console.log("layer:" + obj.id);
    let tempDiv = document.createElement("div");
    tempDiv.setAttribute("class", "swatch ds-center pattern-colors-list");        
    tempDiv.setAttribute("data-hex", obj.fill);        
    tempDiv.setAttribute("style", "margin: -4px 5px 0px 0px; background-color: " + obj.fill);        

    fillColor = obj.fill;
    
    // check duplicates
    if(patternColorsList.indexOf(fillColor) < 0) {
      patternColorsList.push(fillColor);   
      patternColors.append(tempDiv);      
      updateMasterPatternColorsUsed(fillColor, "");
    }
  
    // #click-color-pattern
    tempDiv.addEventListener("click", function() {
        console.log("color mousedown: " + this.getAttribute("data-hex")); //.attr("data-hex").val());
      swapPatternColor(this.getAttribute("data-hex"));
      // change the color of the clicked box; update data-hex and background-color
      $(this).attr("data-hex", colorPalette);
      $(this).css("background-color", colorPalette);   
    });
  });       
}  
  
function showPatternColorsOLD(layers) {

  patternColorsList = [];
  layers.forEach(function(obj) {
    
    console.log("PATTERN: " + obj.type + ", id: "+ obj.id + ", fill: " + obj.fill); 
    // build the list of colors       
    var tempStr = '<div class="swatch ds-center pattern-swatch-color" data-hex="' + obj.fill + '" style="background-color:' + obj.fill + '"></div>';
    // check duplicates
    if(patternColorsList.indexOf(tempStr) < 0)
      patternColorsList.push(tempStr);   
  });  
  
  let patternColors = $("#pattern-colors");
  var patternColorsHeaderDiv = '<div><div style="font-weight: bold">Pattern Colors:</div><div style="margin-bottom: 5px; margin-top: -10px"><span style="font-size: 10px">(click color to swap with active)</span></div></div>';     
  var patternColorsDiv = "";
  
  patternColorsList.forEach(function(obj) {
    console.log("patternColorsList!");
    patternColorsDiv = patternColorsDiv + obj;  
  });

  patternColors.css("font-style", "normal"); 
  patternColors.html(patternColorsHeaderDiv + '<div style="display: flex; flex-wrap: wrap;">' + patternColorsDiv + '</div>'); 
}
 
function setPattern(image, canvas) {
  
  console.log("setPattern!!!!!!!!!!: path: " + pathStr + ", image: " + image);

  var activeObject = null;

  // remove current pattern
  activeObject = getObjectById(canvas, "canvas-pattern-image");
  if(activeObject != null) {                             
    console.log("setPattern: set source, xxxx:" + activeObject.width + ", " + activeObject.height);
    console.log("setPattern: set source, xxxx:" + activeObject.scaleX + ", " + activeObject.scaleY);
    console.log("setPattern: set source, xxxx222:" + activeObject.id + "-" + activeObject.scaleX + ", " + activeObject.scaleY);  
    canvas.remove(activeObject);
    canvas.renderAll();      
  }
  else {
    console.log("No active object, do not delete it.");    
  }
  
  // load desired pattern 
  fabric.loadSVGFromURL(pathStr + image, function(objects, options) {
    
      var img = fabric.util.groupSVGElements(objects, options); 

      showPatternColors(objects);

      console.log("path: " + pathStr + "-" + image);
      console.log("SVG PATTERN: width: " + img.width + ", height: " + img.height);
      if (img.width > canvas.getWidth()) {
          //img.scaleToWidth(canvas.getWidth());
          console.log("SVG PATTERN2: width: " + img.width + ", height: " + img.height);
      }
      if (img.height > canvas.getHeight()) {
          //img.scaleToHeight(canvas.getHeight());
          console.log("SVG PATTERN3: width: " + img.width + ", height: " + img.height);
      }
    
      console.log("SVG PATTERN: width: " + img.width + ", height: " + img.height);
      var x = canvasPattern.width / img.width;
      var y = canvasPattern.height / img.height;
      var factor = 1; // TODO REVERT? patternDefaultFactor;

      var largest = x;
      if(y > x)
        largest = y;
    
      console.log("SVG PATTERN x, y: x: " + x + ", y: " + y + ", factor: " + factor);
    
      img.scaleX = largest * factor;
      img.scaleY = largest * factor;
      console.log("OFFSET: left: " + img.left + ", top: " + img.top);
    
      originalScaleX = largest * factor;
      originalScaleY = largest * factor;

      img.set({
        borderColor: 'red',
        cornerColor: 'black',
        cornerStrokeColor: 'red',
        transparentCorners: false,
        cornerSize: 16
      });    

    
      img.id = "canvas-pattern-image";
      canvas.add(img);
      canvas.sendToBack(img);
      canvas.renderAll();    
    
      console.log("PATTERN SETUP: height: " + img.height + ", width: " + img.width + ", canvas w:" + canvasPattern.width);
  });
  canvas.renderAll();      
}
  
function makeTransparent(paths) {

  var toggle = 0;
  
  paths.forEach(function(obj) {
    if(obj != null) {
      console.log("make transparent Id: " + obj.id);
                    
      if(obj.fill != "" && toggle > 0) {
          obj.set({ opacity: 0 });
      }
      toggle = toggle > 0 ? 0 : 1; 
    }
  });
  canvas.renderAll();      

}
  
function updateColors(key, color) {
    console.log("update colors: key: " + key + ", color: " + color);
  
    let name = $("#colorDisplayText");

    // clear all actives first then set active
    $('[id^="colorName"]').css("font-weight", "normal");    

    // set selected border or indicate selected
    key = key.replaceAll(" ", "-");
    var colorActive = document.getElementById("colorName-" +  key);
    colorActive.setAttribute("style", "font-size: 12px; margin: 7px 4px 0px 3px; font-weight: bold");
  
    key = key.replaceAll("-", " ");
  
    var strDiv = '<div id="typeButtonActiveColorMain" style="display: flex; cursor: pointer;"><div class="swatch ds-center" style="background-color: #' + color + '"></div><div style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + key + '</div></div>';  
    colorPalette = "#" + color;	//saves color to be used when clicking on a group
    colorPaletteName = key;    
  
    name.html(strDiv);
}
  
function updatePattern(key, pattern) {
    let name = $("#patternDisplayText");
    imageName = pattern;
    var strDiv = '<div id="typeButtonPattern" style="display: flex; cursor: pointer;"><div class="swatch swatch-pattern ds-center" style=""><img id="active-pattern-img" class="pattern-img" src="' + pathStr + pattern + '"></div><div style="font-weight: normal; font-size: 12px; margin-top: 5px">' + key + '</div></div>';  
    name.html(strDiv);
}
 
function fillGradient(canvasToFill, isSolid) {  
  var color1 = $("#gradient-color-1").css("background-color");
  var color2 = $("#gradient-color-2").css("background-color");
  var color3 = $("#gradient-color-3").css("background-color");
  var color4 = $("#gradient-color-4").css("background-color");
  var color1hex = $("#gradient-color-1").data("hex-color");
  var color2hex = $("#gradient-color-2").data("hex-color");
  var color3hex = $("#gradient-color-3").data("hex-color");
  var color4hex = $("#gradient-color-4").data("hex-color");
  var color1name = $("#gradient-color-1").data("name-color");
  var color2name = $("#gradient-color-2").data("name-color");
  var color3name = $("#gradient-color-3").data("name-color");
  var color4name = $("#gradient-color-4").data("name-color");
  var coordinates = ""; // top down, 8 options
  // stikrd-range
  var range = $("#stikrd-range").val();
  // gradient-directions
  var direction = $("#gradient-directions").val();
  var colorStops = [
          { offset: 0, color: color1 },
          { offset: 1, color: color2 } ];
        
  console.log("range: " + range + ", direction: " + direction);
  // 100 ideal but want 50
  range = range * 2;
  if(range > 0) {
    range = range / 100;
  }
  
  //clear color array
  masterGradientColorList = [];
  masterGradientColorNameList = [];

  
  console.log("range: " + range + ", direction: " + direction);
  console.log("color1-hex: " + color1hex + ", color1name: " + color1name);
  console.log("color2-hex: " + color2hex + ", color2name: " + color2name);
  console.log("color3-hex: " + color3hex + ", color3name: " + color3name);
  console.log("color4-hex: " + color4hex + ", color4name: " + color4name);
  
  // optional colors
  console.log("checkbox3: " + $("#gradient-checkbox-3").is(':checked'));
  console.log("checkbox4: " + $("#gradient-checkbox-4").is(':checked'));
  updateMasterGradientColorsUsed(color1hex, color1name);
  updateMasterGradientColorsUsed(color2hex, color2name);
  if($("#gradient-checkbox-3").is(':checked') && $("#gradient-checkbox-4").is(':checked')) {
      console.log("checkbox3 AND 4");
      colorStops = [
            { offset: 0, color: color1 },
            { offset: .33, color: color2 }, 
            { offset: .66, color: color3 }, 
            { offset: 1, color: color4 } 
      ];    
      updateMasterGradientColorsUsed(color3hex, color3name);
      updateMasterGradientColorsUsed(color4hex, color4name);
  }
  else {
    if($("#gradient-checkbox-3").is(':checked')) {
      console.log("checkbox3: " + $("#gradient-checkbox-3").is(':checked'));
      colorStops = [
            { offset: 0, color: color1 },
            { offset: .5, color: color2 }, 
            { offset: 1, color: color3 } 
      ];    
      updateMasterGradientColorsUsed(color3hex, color3name);
    }
    if($("#gradient-checkbox-4").is(':checked')) {
      console.log("checkbox4: " + $("#gradient-checkbox-4").is(':checked'));
      colorStops = [
            { offset: 0, color: color1 },
            { offset: .5, color: color2 }, 
            { offset: 1, color: color4 } 
      ];    
      updateMasterGradientColorsUsed(color4hex, color4name);
    }
  }  
  
  canvasToFill.getObjects().forEach(function (obj) {
    if((obj != null && obj.type == "path" && (obj.id.toLowerCase().startsWith("layer_") ) ) 
       || ((obj != null && ((obj.id.toLowerCase().startsWith("outline") && !isSolid)) ))) {
    
      console.log("COMBO fill grad LAYER and TOP 4444: " + obj.id + ", type: " + obj.type + ", color1: " + color1 + ", color2:" + color2 + ", color3: " + color3 + ", color4:" + color4);

      if(direction == 1)
        // top down
        coordinates = { x1: 0, y1: 0, x2: 0, y2: range };
      if(direction == 2)
        // bottom up
        coordinates = { x1: 0, y1: range, x2: 0, y2: 0 };
      if(direction == 3)
        // left to right
        coordinates = { x1: 0, y1: 0, x2: range, y2: 0 };
      if(direction == 4)
        // right to left
        coordinates = { x1: range, y1: 0, x2: 0, y2: 0 };
      if(direction == 5)
        // top right
        coordinates = { x1: 0, y1: 0, x2: range, y2: range };
      if(direction == 6)
        // top left
        coordinates = { x1: range, y1: 0, x2: 0, y2: range };
      if(direction == 7)
        // bottom left
        coordinates = { x1: 0, y1: range, x2: range, y2: 0 };
      if(direction == 8)
        // bottom right
        coordinates = { x1: range, y1: range, x2: 0, y2: 0 };
      var gradient = new fabric.Gradient({
        type: 'linear',
        gradientUnits: 'percentage', // or 'percentage'
        coords: coordinates,
        colorStops: colorStops
      })
      obj.set({ fill: gradient });        
    }
    else if(obj != null && obj.type == "path" && ((obj.id.toLowerCase().startsWith("outline") && !isSolid)) ) {
      console.log("OUTLINE fill grad LAYER and TOP 6666: " + obj.id + ", type: " + obj.type);
    }
    else
      console.log("NO fill grad LAYER and TOP 7777: " + obj.id + ", type: " + obj.type + ", color1: " + color1 + ", color2:" + color2 + ", color3: " + color3 + ", color4:" + color4);
  });
      
  canvasToFill.renderAll();      
}
  
function fillPattern(canvasToFill, isSolid) { 
  
  console.log("fill pattern" + isSolid);

  setPattern(imageName, canvasToFill);
  
  canvasToFill.renderAll();      
}
  
$('#dpid').text(productTitle.toUpperCase());
$('#dpid-footer').text(productTitle.toUpperCase());
$('#dpiddebug').text(getUrlParameter('pid') + ' and Title: ' + getUrlParameter('pn') + '.');
var debug = false;
if(getUrlParameter('debug') == "true") {
  debug = true;
}

fabric.Object.prototype.objectCaching = false;

// create a wrapper around native canvas element
var canvas = new fabric.Canvas('canvas', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas'
});
var canvasGradient = new fabric.Canvas('canvas-gradient', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas-gradient'
});
var canvasPattern = new fabric.Canvas('canvas-pattern', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas-pattern'
});
var canvasOutline = new fabric.Canvas('canvas-outline', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas-outline'
});
var canvasGradientOutline = new fabric.Canvas('canvas-gradient-outline', {
    preserveObjectStacking: true,
    selection: false,    
    id: 'canvas-gradient-outline'
});
var canvasPatternOutline = new fabric.Canvas('canvas-pattern-outline', {
    preserveObjectStacking: true,
    selection: false,
    id: 'canvas-pattern-outline'
});

const zoomMap = new Map();
zoomMap.set(canvas, zoomLevel);
zoomMap.set(canvasOutline, zoomLevel);
zoomMap.set(canvasGradient, zoomLevel);
zoomMap.set(canvasGradientOutline, zoomLevel);
zoomMap.set(canvasPattern, zoomLevel);
zoomMap.set(canvasPatternOutline, zoomLevel);
  
/*
canvas.on('mouse:wheel', function(opt) {
  var delta = opt.e.deltaY;
  var zoom = canvas.getZoom();
  console.log("Zoom: " + zoom + ", delta: " + delta);
  zoom *= 0.999 ** delta;
  console.log("Zoom: " + zoom + ", delta: " + delta);
  
  if (zoom > 20) zoom = 20;
  if (zoom < 0.01) zoom = 0.01;
  canvas.setZoom(zoom);
  opt.e.preventDefault();
  opt.e.stopPropagation();
});
  */
  
const SVG_PATH = "../cdn/shop/"; 
  
// use server side var for path
var site_url_path = SVG_PATH + svgImageFile + "?v=" + qs_cachebuster;
console.log("svgImageFile : " + site_url_path);
    
var site_url = site_url_path; //imgElement.src;
var site_url_outline =  site_url_path.replace("_SOLID.svg", "_OUTLINE.svg");
    
var site_url_gradient =  site_url_path.replace("_SOLID.svg", "_SOLID_GRADIENT.svg");
var site_url_gradient_outline =  site_url_path.replace("_SOLID.svg", "_OUTLINE_GRADIENT.svg");

var site_url_pattern =  site_url_path.replace("_SOLID.svg", "_SOLID_PATTERN.svg");
var site_url_pattern_outline =  site_url_path.replace("_SOLID.svg", "_OUTLINE_PATTERN.svg");
var init = true;  
console.log("site_ur: " + site_url + ", outline: " + site_url_outline + ", new: " + site_url_pattern);
  
var previousColor = "";
var hoverColor = "#CCFF00";
var activeTab = 1;
var usedColorsList = [];
var patternColorsList = [];
var productBoundingWidth = 725;
var productBoundingHeight = 725;
  
// TODO-062625 moved create colors and patterns
  
// scale actual svg onto this canvas
function scaleSvg(canvas, objSVG) {
  var scaleFactor = 0;
  var juice = 2;
  
  console.log("bound w: " + productBoundingWidth + ", bound h: " + productBoundingHeight);
  console.log("width: " + objSVG.width + ", height: " + objSVG.height);
  
  // only scale to the width
  scaleFactor = (productBoundingWidth) / (objSVG.width - juice);
  
  console.log("scale factor ZZ22: " + scaleFactor);
  objSVG.scale(scaleFactor);
  
  if(objSVG.height * scaleFactor > productBoundingHeight) {
    console.log("y gt x: " + canvas.getWidth() + ", height--u  : " + objSVG.height);
    canvas.setDimensions({ width: canvas.getWidth(), height: objSVG.height * scaleFactor });
  }
}  
  
// scale actual svg onto this canvas
function scaleSvgObjects(canvas, objSVG, objects) {
  var scaleFactor = 0;

  console.log("bound w: " + productBoundingWidth + ", bound h: " + productBoundingHeight);
  console.log("width: " + objSVG.width + ", height: " + objSVG.height);

  // only scale to the width
  scaleFactor = (productBoundingWidth) / objSVG.width;
    
  console.log("scale factor: " + scaleFactor);

  objects.forEach(function (obj) {
    console.log("for each obj!: " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top);    
    obj.scale(scaleFactor);
  });
  
  if(objSVG.height * scaleFactor > productBoundingHeight) {
    console.log("y gt x: " + canvas.getWidth() + ", height--u  : " + objSVG.height);
    canvas.setDimensions({ width: canvas.getWidth(), height: objSVG.height * scaleFactor });
  }
}  

  
function updateMasterColorsFromLayers(canvas) {
    var colorList = [];
    masterColorList = [];
    masterColorNameList = [];
    canvas.getObjects().forEach(function (obj) {
      if(obj.id != null && obj.id.toLowerCase().startsWith("layer")) { 
        console.log("fill? : " + obj.type + ", id: "+ obj.id + ", fill: " + obj.fill + ", name: " + obj.colorName);    
        if(colorList.indexOf(obj.fill) < 0) {
          colorList.push(obj.fill);
          masterColorList.push(obj.fill);
          if(obj.colorName != undefined && obj.colorName != null)
            masterColorNameList.push(obj.colorName);
          else
            masterColorNameList.push("Default");
            
        }
      }
    });
    return colorList;
}  

function createMasterColorListHtml(masterColorList, masterColorNameList) {
    var i = 0;
    var usedColorsHtml = "";
    masterColorList.forEach(function(obj) {
      console.log("hex: " + obj + ", i:" + i + ", name lookup: " + masterColorNameList[i]);
      var template = '<div style="display: flex"><div class="swatch ds-center" style="background-color:' + obj + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + masterColorNameList[i] + '</div></div>';

      usedColorsHtml = usedColorsHtml + template; 
      i++;
    });  
    return usedColorsHtml;
} 

  
function createMasterColorNameList(masterColorNameList) {
    var separator = "";
    var usedColors = "";
  
    masterColorNameList.forEach(function(obj) {
      console.log("create name: " + obj);
      if(separator.length > 0)
        usedColors = usedColors + ", ";  
      usedColors = usedColors + obj;  
      separator = "true";
    });
    return usedColors;
}

  
function updateCustomColors(canvas) {
  var usedColors = "";
  var usedColorsHtml = "";
  var layerColorList = [];
  
  console.log("KOLORS: updateCustomColors: ");
  
  let activeTab = getActiveTab();
  if(activeTab == 1) {  
  
    // integrity check, user may have used color but then overwrote it with another
    layerColorList = updateMasterColorsFromLayers(canvas);
    
    console.log("color list : " + layerColorList);    

    usedColorsHtml = createMasterColorListHtml(masterColorList, masterColorNameList);
    usedColors = createMasterColorNameList(masterColorNameList);
  }  
  if(activeTab == 2) {  
    masterGradientColorList.forEach(function(obj) {
      console.log("gradient hex: " + obj);
    });
    usedColorsHtml = createMasterColorListHtml(masterGradientColorList, masterGradientColorNameList);    
    
    masterGradientColorNameList.forEach(function(obj) {
      console.log("gradient name: " + obj);
    });
    usedColors = createMasterColorNameList(masterGradientColorNameList);
    console.log("used colors: " + usedColors);
    
  }
  else if(activeTab == 3) {  
    masterPatternColorList.forEach(function(obj) {
      console.log("hex: " + obj);
    });
    usedColorsHtml = createMasterColorListHtml(masterPatternColorList, masterPatternColorNameList);    
    
      console.log("mcnl0: " + masterPatternColorNameList.length);
    for(i = 0; i < masterPatternColorNameList.length; i++) {
      console.log("mcnl: i: " + i + ", " + masterPatternColorNameList[i]);
    }

    
    masterPatternColorNameList.forEach(function(obj) {
      console.log("debug name: " + obj);
    });
    usedColors = createMasterColorNameList(masterPatternColorNameList);
    console.log("used colors: " + usedColors);
  }

  $("#custom-colors").val(usedColors);
  $("#custom-colors-html").val(usedColorsHtml);
}

  
function addLegend(canvas) {
  console.log("Add legend..." + canvas + ", mainH: "+ mainHeight + ", canvasH: " + canvas.height + ", mainW: " + mainWidth + ", canvasW: " + canvas.width);

  var topLegend = mainHeight / 2; //canvas.height;
  var left = mainWidth / 2 * -1;
  var topInner = 20;
  var offset = -125;
  var leftInner = offset;

  console.log("top: " + topLegend + ", left: " + left + ", topInner: " + topInner + ", leftInner: " + leftInner);
  
  // find corresponding legend object and add 
  var activeObject = getObjectById(canvas, "legend");
  if(activeObject != null) {
    console.log("legend exists: " + activeObject.id);
    canvas.remove(activeObject);
    canvas.renderAll();
  }

  var circle = null;
  var pantone = null;
  var text = new fabric.Text(designId, {
    fontSize: 24
  });
  
  var group = new fabric.Group([ text ], {
    id: "legend",
    left: left,
    top: topLegend
  });
  
  let activeTab = getActiveTab();
  if(activeTab == 1) {  

  // integrity check, user may have used color but then overwrote it with another
    
    masterColorList.forEach(function(obj) {
      console.log("hex: " + obj);
      circle = new fabric.Circle({
        radius: 20, fill: obj, left: leftInner, top: topInner
      });
      group.add(circle);
      leftInner = leftInner + 50;
    });
    
    topInner = topInner + 25;
    masterColorNameList.forEach(function(obj) {
      console.log("name: " + obj);
      topInner = topInner + 20;
      pantone = new fabric.Text(obj, {
        fontSize: 16,
        left: offset,
        top: topInner
      });
      group.add(pantone);
    });
  }  
  if(activeTab == 2) {  
    masterGradientColorList.forEach(function(obj) {
      console.log("hex: " + obj);
      circle = new fabric.Circle({
        radius: 20, fill: obj, left: leftInner, top: topInner
      });
      group.add(circle);
      leftInner = leftInner + 50;
    });
    
    topInner = topInner + 25;
    masterGradientColorNameList.forEach(function(obj) {
      console.log("name: " + obj);
      topInner = topInner + 20;
      pantone = new fabric.Text(obj, {
        fontSize: 16,
        left: offset,
        top: topInner
      });
      group.add(pantone);
    });
  }
  else if(activeTab == 3) {  
    masterPatternColorList.forEach(function(obj) {
      console.log("hex: " + obj);
      circle = new fabric.Circle({
        radius: 20, fill: obj, left: leftInner, top: topInner
      });
      group.add(circle);
      leftInner = leftInner + 50;
    });
    
    topInner = topInner + 25;
    masterPatternColorNameList.forEach(function(obj) {
      console.log("name: " + obj);
      topInner = topInner + 20;
      pantone = new fabric.Text(obj, {
        fontSize: 16,
        left: offset,
        top: topInner
      });
      group.add(pantone);
    });
  }
  canvas.add(group); 
  //canvas.sendToBack(group);
  //canvas.sendBackwards(group);
  canvas.renderAll();
}
  
function updateMasterColorsUsed(hex, name) {
  console.log("KOLORS: updateMasterColorsUsed: Add to list: hex: " + hex + ", name: " + name);
  
  // check duplicates
  if(masterColorList.indexOf(hex) < 0) {
    masterColorList.push(hex);
    masterColorNameList.push(name);
  } 
}
  
function updateMasterGradientColorsUsed(hex, name) {
  console.log("mgrad hex: " + hex + ", mgrad name: " + name);
  
  // check duplicates
  if(masterGradientColorList.indexOf(hex) < 0) {
    masterGradientColorList.push(hex);
    masterGradientColorNameList.push(name);
  } 
}

function updateMasterPatternColorsUsed(hex, name) {
  console.log("hex: " + hex + ", update name: " + name);
  
  // check duplicates
  if(masterPatternColorList.indexOf(hex) < 0) {
    masterPatternColorList.push(hex);
    if(name == null || name == "")
      masterPatternColorNameList.push("Default");
    else
      masterPatternColorNameList.push(name);
  } 
}

  
function swapMasterPatternColorsUsed(currentColor) {
  
  console.log("currentColor: " + currentColor);
  
  // check duplicates
  if(masterPatternColorList.indexOf(currentColor) >= 0) {
    for (var i = 0; i < masterPatternColorList.length; i ++) {
        if (masterPatternColorList[i] == currentColor) { 
            console.log("pop: " + currentColor);
            masterPatternColorList.splice(i, 1);
            masterPatternColorNameList.splice(i, 1);
            // pop name????
            break;
        }
    }    
    console.log("push: " + colorPalette);
    masterPatternColorList.push(colorPalette);
    masterPatternColorNameList.push(colorPaletteName);
  }   
} 

function isPixelOpaque(obj, pointer) {
  // create a temporary offscreen canvas
  const tempCanvas = fabric.util.createCanvasElement();
  tempCanvas.width = obj.width * obj.scaleX;
  tempCanvas.height = obj.height * obj.scaleY;
  const ctx = tempCanvas.getContext('2d');

  // render the object onto it
  const tempObj = fabric.util.object.clone(obj);
  tempObj.left = 0;
  tempObj.top = 0;
  tempObj.render(ctx);

  // convert pointer to local object coordinates
  const local = obj.toLocalPoint(new fabric.Point(pointer.x, pointer.y), 'center', 'center');

  const px = Math.round(local.x + tempCanvas.width / 2);
  const py = Math.round(local.y + tempCanvas.height / 2);

  if (px < 0 || py < 0 || px >= tempCanvas.width || py >= tempCanvas.height) {
    return false;
  }

  const pixel = ctx.getImageData(px, py, 1, 1).data;
  return pixel[3] > 0; // alpha channel > 0 = opaque
}

  
var mainWidth = 350;  
var mainHeight = 350;  
var textNotAvailable = new fabric.Text('This sticker is not\navailable at this time.', { left: 100, top: 100, textAlign: 'center' });
  
// canvas main home solid #1 
function initColorSwap() {  
  fabric.loadSVGFromURL(site_url, function(objects, options) {

  console.log("#1 " + site_url);
    if(null != objects) {
      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      if(objSVG != null) {
        mainWidth = objSVG.width;
        mainHeight = objSVG.height;
        //console.log("objSVG width: " + objSVG.width); // + ", " + objSVG.objects.length); 
      }
      //else
      //  console.log("objSVG null: "); 
      
      objects.forEach(function(obj) {
  
        //console.log("#1 SOLID and SWAP name center!: " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top); 
        
        // don't allow object to be moved or stretched
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        })
    
        //console.log("fill solid layer 1: " + obj.type + ", id: "+ obj.id + ""); 
        if(obj.id.toLowerCase().startsWith("layer")) { 
          // == "layer_1" || obj.id.toLowerCase() == "layer_2" || obj.id.toLowerCase() == "layer_3" || obj.id.toLowerCase() == "layer_4" || obj.id.toLowerCase() == "layer_5" || obj.id.toLowerCase() == "layer_6" ||obj.id.toLowerCase() == "layer_7" || obj.id.toLowerCase() == "layer_8") {
          //console.log("IN fill solid layer X: " + obj.type + ", id: "+ obj.id); 
  
          // mouse over
          obj.on("mouseover", function(){
            if(this.fill != "") {
              previousColor = this.fill;
              this.set({ fill: hoverColor });
            }        
            canvas.renderAll();
          });
        
          // mouse out
          obj.on("mouseout", function(){
            if(this.fill != "") {
              if(this.fill == hoverColor)
                this.set({ fill: previousColor });
            }        
            canvas.renderAll();
          });
    
          // fill with active color
          obj.on("mousedown", function(){ 
              if(this.fill != "") {
                this.set({ fill: colorPalette });
                this.colorName = colorPaletteName;
              }

            
              // find corresponding outline object and update
              activeObject = getObjectById(canvasOutline, obj.id);
              if(activeObject != null) {
                //console.log("GETIT7: " + activeObject.id);
                activeObject.set({ fill: colorPalette });
                activeObject.colorName = colorPaletteName;
                canvasOutline.renderAll();
              }
            
              canvas.renderAll();
              let usedColors = $("#used-colors");
              var tempStr = '<div style="display: flex"><div id="' + colorPaletteName.replaceAll(" ", "-") + '" class="swatch ds-center" data-hex="' + colorPalette + '" style="background-color:' + colorPalette + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + colorPaletteName + '</div></div>';
              var usedColorsDiv = '<div class="stikrd">Colors Used:</div>';
              // check duplicates
              if(usedColorsList.indexOf(tempStr) < 0)
                usedColorsList.push(tempStr);
             
              usedColorsList.forEach(function(obj) {
                //console.log("usedColorsList!");
                usedColorsDiv = usedColorsDiv + obj;  
              });
            
              usedColors.css("font-style", "normal"); 
              usedColors.html(usedColorsDiv); 

              updateMasterColorsUsed(colorPalette, colorPaletteName);
          });
        }       
        canvas.add(obj); //.renderAll();
        
      });  
  
      scaleSvg(canvas, objSVG);
    }
    else {
      canvas.add(textNotAvailable).renderAll;    
    }

    canvas.renderAll();

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvas.on('mouse:down', function(opt) {
      const evt = opt.e;
      isDragging = true;
      canvas.selection = false;
      lastPosX = evt.clientX;
      lastPosY = evt.clientY;
    });

    canvas.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvas.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvas.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvas.on('mouse:up', function(opt) {
      isDragging = false;
      canvas.selection = true;
    });
    
  });
}
  
// canvas main home outline #2
function initColorSwapOutline() {
  fabric.loadSVGFromURL(site_url_outline, function(objects, options) {
    if(null != objects) {
      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      /*if(objSVG != null)
            console.log("objSVG OUTLINE: " + objSVG); 
      else
            console.log("objSVG OUTLINE null: "); 
      */
      objects.forEach(function(obj) {
                                       
        // don't allow object to be moved or stretched
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        })
        
        if(obj.id.toLowerCase().startsWith("layer")) {         
          //obj.set({ fill: "#CCCCCC" });
          
          // mouse over
          obj.on("mouseover", function(){
            //console.log("mouseover outline 111");
            if(this.fill != "") {
              previousColor = this.fill;
              this.set({ fill: hoverColor });
            }        
            canvasOutline.renderAll();
          });
        
          // mouse out
          obj.on("mouseout", function(){
            if(this.fill != "") {
              if(this.fill == hoverColor)
                this.set({ fill: previousColor });
            }        
            canvasOutline.renderAll();
          });
    
          // fill with active color
          obj.on("mousedown", function(){ 
              if(this.fill != "") {
                this.set({ fill: colorPalette });
                this.colorName = colorPaletteName;
              }
            
              // find corresponding outline object and update
              activeObject = getObjectById(canvas, obj.id);
              if(activeObject != null) {
                //console.log("GETIT#22: " + activeObject.id);
                activeObject.set({ fill: colorPalette });
                activeObject.colorName = colorPaletteName;
                canvas.renderAll();
              }
              //console.log("1111 obj id: " + this.type + ", id:" + this.id); 
    
              let usedColors = $("#used-colors");
              var tempStr = '<div style="display: flex"><div id="' + colorPaletteName.replaceAll(" ", "-") + '" class="swatch ds-center" data-hex="' + colorPalette + '" style="background-color:' + colorPalette + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + colorPaletteName + '</div></div>';
              var usedColorsDiv = '<div style="font-weight: bold">Colors Used:</div>';
              // check duplicates
              if(usedColorsList.indexOf(tempStr) < 0)
                usedColorsList.push(tempStr);
             
              usedColorsList.forEach(function(obj) {
                //console.log("usedColorsList!");
                usedColorsDiv = usedColorsDiv + obj;  
              });
              usedColors.css("font-style", "normal"); 
              usedColors.html(usedColorsDiv); 
            
              updateMasterColorsUsed(colorPalette, colorPaletteName);
            
              canvasOutline.renderAll();
          });    
        }
        else if(obj.id.toLowerCase() == "background") {                               
          // canvasOutline.add(obj).renderAll;
          //console.log("background check");
        }
        canvasOutline.add(obj); //.renderAll;
        
      });  
  
      scaleSvg(canvasOutline, objSVG);
    }
    else {
      canvasOutline.add(textNotAvailable).renderAll;    
    }
    
    canvasOutline.renderAll();

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasOutline.on('mouse:down', function(opt) {
      const evt = opt.e;
      isDragging = true;
      canvasOutline.selection = false;
      lastPosX = evt.clientX;
      lastPosY = evt.clientY;
    });

    canvasOutline.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasOutline.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasOutline.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasOutline.on('mouse:up', function(opt) {
      isDragging = false;
      canvasOutline.selection = true;
    });


  });
}

  
// canvas gradient #3
function initGradient() {
  fabric.loadSVGFromURL(site_url_gradient, function(objects, options) {
    if(null != objects) {

        // Iterate over each object in the SVG
        console.log('#3 SVG loaded successfully! Total objects: ' + objects.length);
        console.log('-----------------------------------');
        objects.forEach((obj, index) => {
            console.log(`Object ${index + 1}:`);
            console.log(`  Type: ${obj.type}`); // e.g., 'circle', 'rect', 'path', 'group', 'i-text'
            console.log(`  Left: ${obj.left}`);
            console.log(`  Top: ${obj.top}`);
            obj.originalLeft = obj.left;
            obj.originalTop = obj.top;
            console.log(`  Width: ${obj.width}`);
            console.log(`  Height: ${obj.height}`);
            console.log(`  Fill Color: ${obj.fill}`);
            // Check for common properties like ID
            if (obj.id) {
                 console.log(`  ID: ${obj.id}`);
            }
            // Check for specific text properties if it's a text object
            if (obj.type === 'i-text' || obj.type === 'text') {
                console.log(`  Text Content: ${obj.text}`);
            }
            console.log('-----------------------------------');
        });
            
      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      /*if(objSVG != null)
            console.log("objSVG: #3:" + objSVG); 
      else
            console.log("objSVG null: "); 
      */

      objects.forEach(function(obj) {
            
        console.log("objSVG: #3 foreach set lock etc"); 
        // don't allow object to be moved or stretched
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        })

        if(obj.id.toLowerCase().startsWith("overlay") && obj.fill.toLowerCase() == "#ffffff" && (obj.originalLeft > 0.5 && obj.originalTop > 0.5)) {         
          //obj.set({ fill: "#CCCCCC" });
          //console.log("333OVERLAY===" + obj.id);
          // mouse over
          obj.on("mouseover", function(){
            //console.log("mouseover outline 333" + this.id);
            if(this.fill != "") {
              previousColor = this.fill;
              this.set({ fill: hoverColor });
            }        
            canvasGradient.renderAll();
          });
        
          // mouse out
          obj.on("mouseout", function(){
            if(this.fill != "") {
              if(this.fill == hoverColor)
                this.set({ fill: previousColor });
            }        
            canvasGradient.renderAll();
          });
          
          // fill with active color
          obj.on("mousedown", function(){ 
              if(this.fill != "") {
                this.set({ fill: colorPalette });
                this.colorName = colorPaletteName;
              }
            
              // find corresponding outline object and update
              /* activeObject = getObjectById(canvasGradientOutline, obj.id);
              if(activeObject != null) {
                console.log("GETIT#33: " + activeObject.id);
                activeObject.set({ fill: colorPalette });
                activeObject.colorName = colorPaletteName;
                canvasGradientOutline.renderAll();
              } */
              //console.log("3333 obj id: " + this.type + ", id:" + this.id); 
    
              let usedColors = $("#used-colors");
              var tempStr = '<div style="display: flex"><div id="' + colorPaletteName.replaceAll(" ", "-") + '" class="swatch ds-center" data-hex="' + colorPalette + '" style="background-color:' + colorPalette + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + colorPaletteName + '</div></div>';
              var usedColorsDiv = '<div style="font-weight: bold">Colors Used:</div>';
              // check duplicates
              if(usedColorsList.indexOf(tempStr) < 0)
                usedColorsList.push(tempStr);
             
              usedColorsList.forEach(function(obj) {
                //console.log("usedColorsList!");
                usedColorsDiv = usedColorsDiv + obj;  
              });
              usedColors.css("font-style", "normal"); 
              usedColors.html(usedColorsDiv); 
            
              updateMasterColorsUsed(colorPalette, colorPaletteName);
            
              canvasGradient.renderAll();
          });   
        
        }
        else {
          console.log("No match: id: " + obj.id + ", fill: " + obj.fill + ", left: " + obj.originalLeft + ", top: " + obj.originalTop);
        }
        
        canvasGradient.add(obj).renderAll;    
      });  
      
      // fill with a gradient with the default color
      fillGradient(canvasGradient, true);
      
      scaleSvg(canvasGradient, objSVG);
    }
    else {
      canvasGradient.add(textNotAvailable).renderAll;    
    }
    
    canvasGradient.renderAll();

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasGradient.on('mouse:down', function(opt) {
      const evt = opt.e;
      isDragging = true;
      canvasGradient.selection = false;
      lastPosX = evt.clientX;
      lastPosY = evt.clientY;
    });

    canvasGradient.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasGradient.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasGradient.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasGradient.on('mouse:up', function(opt) {
      isDragging = false;
      canvasGradient.selection = true;
    });

  });
}
 
// canvas gradient outline #4
function initGradientOutline() {
  fabric.loadSVGFromURL(site_url_gradient_outline, function(objects, options) {

    if(null != objects) {
      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      /*if(objSVG != null)
            console.log("objSVG: #4:" + objSVG); 
      else
            console.log("objSVG null: #4"); 
      
      console.log("objects: #4:" + objects); 
      */

      objects.forEach(function(obj) {
            
        // don't allow object to be moved or stretched
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        })
        
        canvasGradientOutline.add(obj).renderAll;    
      });  
      
      // fill the gradient outline with the default color
      fillGradient(canvasGradientOutline, false);
        
      scaleSvg(canvasGradientOutline, objSVG);
    }
    else {
      canvasGradientOutline.add(textNotAvailable).renderAll;    
    }
    canvasGradientOutline.renderAll();

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasGradientOutline.on('mouse:down', function(opt) {
      const evt = opt.e;
      isDragging = true;
      canvasGradientOutline.selection = false;
      lastPosX = evt.clientX;
      lastPosY = evt.clientY;
    });

    canvasGradientOutline.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasGradientOutline.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasGradientOutline.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasGradientOutline.on('mouse:up', function(opt) {
      isDragging = false;
      canvasGradientOutline.selection = true;
    });    
  });
}

// canvas pattern #5
function initPattern() {  

  // load the main custom image
  fabric.loadSVGFromURL(site_url_pattern, function(objects, options) {
    if(null != objects) {

       // Iterate over each object in the SVG
      console.log('#5 SVG loaded #5 successfully! Total objects: ' + objects.length);
      console.log('-----------------------------------');
     objects.forEach((obj, index) => {
          /* console.log(`Object ${index + 1}:`);
          console.log(`  Type: ${obj.type}`); // e.g., 'circle', 'rect', 'path', 'group', 'i-text'
          console.log(`  Left: ${obj.left}`);
          */
          obj.originalLeft = obj.left;
          obj.originalTop = obj.top;
          /* console.log(`  Top: ${obj.top}`);
          console.log(`  Width: ${obj.width}`);
          console.log(`  Height: ${obj.height}`);
          console.log(`  Fill Color: ${obj.fill}`);
          */
          // Check for common properties like ID
          /*if (obj.id) {
               console.log(`  ID: ${obj.id}`);
          }*/
          // Check for specific text properties if it's a text object
          if (obj.type === 'i-text' || obj.type === 'text') {
              console.log(`  Text Content: ${obj.text}`);
          }
          //console.log('-----------------------------------');
      }); 
      
      var objSVG = fabric.util.groupSVGElements(objects, options);
      
      /*if(objSVG != null) {
        console.log("YYobjSVG: " + objSVG.left + ", top: " + objSVG.top); 
      }
      else
        console.log("objSVG null: "); 
      */

      objects.forEach(function(obj) {
        
        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        });

        if(obj.id.toLowerCase().startsWith("overlay") && obj.fill.toLowerCase() == "#ffffff" && (obj.originalLeft > 0 && obj.originalTop > 0)) {         
          
          /*if(obj.left <= 0 && obj.top <= 0 && obj.fill.toLowerCase() == "#ffffff") {
            console.log("Background??????????? " + obj.id);
          }
            */
            //console.log("5555OVERLAY and WHITE FILL===" + obj.id);
            // mouse over
            obj.on("mouseover", function(){
          //console.log("Mouse over: id: " + obj.id + ", fill: " + obj.fill + ", left: " + obj.left + ", top: " + obj.top);
              if(this.fill != "") {
                previousColor = this.fill;
                this.set({ fill: hoverColor });
              }        
              canvasPattern.renderAll();
            });
          
            // mouse out
            obj.on("mouseout", function(){
              if(this.fill != "") {
                if(this.fill == hoverColor)
                  this.set({ fill: previousColor });
              }        
              canvasPattern.renderAll();
            });
            
            // fill with active color
            obj.on("mousedown", function(){ 
                if(this.fill != "") {
                  this.set({ fill: colorPalette });
                  this.colorName = colorPaletteName;
                }
              
                // find corresponding solid object and update
                activeObject = getObjectById(canvasPatternOutline, obj.id);
                if(activeObject != null) {
                  //console.log("GETIT#55: " + activeObject.id);
                  activeObject.set({ fill: colorPalette });
                  activeObject.colorName = colorPaletteName;
                  canvasPatternOutline.renderAll();
                }
                //console.log("555555 obj id: " + this.type + ", id:" + this.id); 
      
                let usedColors = $("#used-colors");
                var tempStr = '<div style="display: flex"><div id="' + colorPaletteName.replaceAll(" ", "-") + '" class="swatch ds-center" data-hex="' + colorPalette + '" style="background-color:' + colorPalette + '"></div><div class="stikrd-custom-color" style="font-size: 12px; margin: 2px 4px; font-weight: normal">' + colorPaletteName + '</div></div>';
                var usedColorsDiv = '<div style="font-weight: bold">Colors Used:</div>';
                // check duplicates
                if(usedColorsList.indexOf(tempStr) < 0)
                  usedColorsList.push(tempStr);
               
                usedColorsList.forEach(function(obj) {
                  //console.log("usedColorsList!");
                  usedColorsDiv = usedColorsDiv + obj;  
                });
                usedColors.css("font-style", "normal"); 
                usedColors.html(usedColorsDiv); 
              
                updateMasterColorsUsed(colorPalette, colorPaletteName);
              
                canvasPattern.renderAll();
            });  
        }
        else {
          console.log("No match: id: " + obj.id + ", fill: " + obj.fill + ", left: " + obj.originalLeft + ", top: " + obj.originalTop);
        }
        //canvasPattern.targetFindTolerance = 0;
        
        canvasPattern.add(obj).renderAll;    
      });
  
  
      scaleSvg(canvasPattern, objSVG);
    }
    else {
      canvasPattern.add(textNotAvailable).renderAll;    
    }
    
    canvasPattern.renderAll(); 

    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasPattern.on('mouse:down', function(opt) {

      const target = opt.target;
      if (target) {
        const pointer = canvas.getPointer(opt.e);
        if(target.type == "group" || target.type == "image") //isPixelOpaque(target, pointer)) 
          console.log("clicked on a visible (non-transparent) pixel of GROUP/IMAGE:", target.type);        
        else {
          console.log("✅ Clicked on a visible (non-transparent) pixel of:", target.type);

          const evt = opt.e;
          isDragging = true;
          canvasPattern.selection = false;
          lastPosX = evt.clientX;
          lastPosY = evt.clientY;

        }
      } else {
        console.log("❌ Clicked on a transparent part (no hit detected).");
      }

    });

    canvasPattern.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasPattern.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasPattern.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasPattern.on('mouse:up', function(opt) {
      isDragging = false;
      canvasPattern.selection = true;
    });


  });
}
 
// canvas pattern outline #6
function initPatternOutline() {  

  fabric.loadSVGFromURL(site_url_pattern_outline, function(objects, options) {
    if(null != objects) {

       // Iterate over each object in the SVG
      console.log('#6 SVG loaded #6 successfully! Total objects: ' + objects.length);
      //console.log('-----------------------------------');
       objects.forEach((obj, index) => {
          /*console.log(`Object ${index + 1}:`);
          console.log(`  Type: ${obj.type}`); // e.g., 'circle', 'rect', 'path', 'group', 'i-text'
          console.log(`  Left: ${obj.left}`);
          */
          obj.originalLeft = obj.left;
          obj.originalTop = obj.top;
          /* console.log(`  Top: ${obj.top}`);
          console.log(`  Width: ${obj.width}`);
          console.log(`  Height: ${obj.height}`);
          console.log(`  Fill Color: ${obj.fill}`);
          */
          // Check for common properties like ID
          /*if (obj.id) {
               console.log(`  ID: ${obj.id}`);
          }
               */
          // Check for specific text properties if it's a text object
          if (obj.type === 'i-text' || obj.type === 'text') {
              console.log(`  Text Content: ${obj.text}`);
          }
          //console.log('-----------------------------------');
      }); 



      var objSVG = fabric.util.groupSVGElements(objects, options);
  
      /*if(objSVG != null) {
        console.log("YYobjSVG: " + objSVG.left + ", top: " + objSVG.top); 
      }
      else
        console.log("objSVG null: "); 
*/
      objects.forEach(function(obj) {

        obj.set({
          hasControls: false,
          hasBorders: false,
          lockMovementX: true,
          lockMovementY: true,
          perPixelTargetFind: true
        });
          
        canvasPatternOutline.add(obj).renderAll;    
      });

      scaleSvg(canvasPatternOutline, objSVG);
    }
    else {
      canvasPatternOutline.add(textNotAvailable).renderAll;    
    }
    
    canvasPatternOutline.renderAll();  
    
    // Drag
    let isDragging = false;
    let lastPosX = 0;
    let lastPosY = 0;

    canvasPatternOutline.on('mouse:down', function(opt) {
      const target = opt.target;
      if (target) {
        if(target.type == "group" || target.type == "image")
          console.log("clicked on a visible (non-transparent) pixel of GROUP/IMAGE:", target.type);        
        else {
          console.log("✅ Clicked on a visible (non-transparent) pixel of:", target.type);

          const evt = opt.e;
          isDragging = true;
          canvasPattern.selection = false;
          lastPosX = evt.clientX;
          lastPosY = evt.clientY;

        }
      } else {
        console.log("❌ Clicked on a transparent part (no hit detected).");
      }
    });

    canvasPatternOutline.on('mouse:move', function(opt) {
      if (isDragging) {
        const e = opt.e;
        const vpt = canvasPatternOutline.viewportTransform;

        vpt[4] += e.clientX - lastPosX;
        vpt[5] += e.clientY - lastPosY;

        canvasPatternOutline.requestRenderAll();

        lastPosX = e.clientX;
        lastPosY = e.clientY;
      }
    });

    canvasPatternOutline.on('mouse:up', function(opt) {
      isDragging = false;
      canvasPatternOutline.selection = true;
    });    

    
  }); 
}

// call each panel and setup  
initColorSwap();  
initColorSwapOutline();
initGradient();  
initGradientOutline();
initPattern();  
initPatternOutline();

//TODO - 062625 moved to ready  , first clicks

$('#myTab a').click(function (e) {
  e.preventDefault();
  $(this).show();
})

$('#myTab button').click(function (e) {
  e.preventDefault();
  $(this).show();
})

//TODO - 062625 moved to ready some click events
  
$('#home-tab').click(function (e) {
  console.log("home click....");
  activeTab = 1;
  e.preventDefault();
  setMainView(activeTab, isSolid);
  $("#pattern-container").hide(); 
  $("#btn-help-1").show();
  $("#btn-help-2").hide();
  $("#btn-help-3").hide();
});

$('#gradient-tab').click(function (e) {
  console.log("gradient click");
  activeTab = 2;
  e.preventDefault();
  setMainView(activeTab, isSolid);
  $("#pattern-container").hide();  
  $("#btn-help-2").show();
  $("#btn-help-1").hide();
  $("#btn-help-3").hide();
});

$('#pattern-tab').click(function (e) {
  console.log("pattern click");
  activeTab = 3;
  e.preventDefault();
  setMainView(activeTab, isSolid);
  // show patterns
  $("#pattern-container").show();


  $("#btn-help-3").show();
  $("#btn-help-1").hide();
  $("#btn-help-2").hide();
});


// #addtocart
$('#btn-add-to-cart').click(function (e) {
  console.log("add to cart handler...");  
  $('#modal-acknowledgement').modal('show');
  return false;
});
$('#btn-add-to-cart-sticky').click(function (e) {
  console.log("add to cart handler...");  
  $('#modal-acknowledgement').modal('show');
  return false;
});

var waitForMe = true;
  
setTimeout(postProcessFunc, 4000);  
  
// TODO - 062625 ready move click
  
function postProcessFunc() {
  $('[class^="_BarWrapper_"]').hide();
  waitForMe = false;
  $(".overlay").hide();
  console.log("post process events typeButton regualr click : " + ", ID: " + $('[id^="typeButton"]').first().attr("id") + ", -ct: " + $('[id^="typeButton"]').length + ", " + $('[id^="typeButton"]').first().length);

}

//TODO - 062625 moved to ready caret click
  

// slider gradient setup
var slider = document.getElementById("stikrd-range");
var output = document.getElementById("gradient-strength-value");
output.innerHTML = slider.value;

slider.oninput = function() {
  output.innerHTML = this.value;

  fillGradient(canvasGradient, isSolid);
  fillGradient(canvasGradientOutline, isSolid);
  console.log("gradient slider move, solid? " + isSolid);
}

// slider pattern setup
var sliderPattern = document.getElementById("stikrd-pattern-range");
var outputPattern = document.getElementById("pattern-stretch-value");
outputPattern.innerHTML = sliderPattern.value;

// stretch pattern  
sliderPattern.oninput = function() {
  outputPattern.innerHTML = this.value;
  console.log("slide stretch..." + this.value);
  var factor = 1;
  var activeObj = null;
  var activeObjOutline = null;

  // SOLID -----------------------------------------------------------
  activeObject = getObjectById(canvasPattern, "canvas-pattern-image");
  if(activeObject == null) {
    console.log("could not find active pattern object...");
  }
  else {
    // expand / shrink image based on slider
    factor = (1 + (this.value * .01));
    console.log("slide2...factor:" + factor + ", origScaleX: " + originalScaleX + ", origScaleY: " + originalScaleY + ", activeScaleX: " + activeObject.scaleX + ", actScaleY: " + activeObject.scaleY + ", num:" + this.value);
    
    console.log("left: " + activeObject.left + ", top: " + activeObject.top);
    
    var scaleX = originalScaleX; //activeObject.scaleX;
    var scaleY = originalScaleY; //activeObject.scaleY;
    var left = 0; 
    var top = 0; 

    var tempScaleX = scaleX * factor;
    var tempScaleY = scaleY * factor;
    var tempLeft = (625 * factor) - 625;
    var tempTop = (625 * factor) - 625;

    activeObject.scaleX = tempScaleX;
    activeObject.scaleY = tempScaleY;
    
    activeObject.left = tempLeft * -1;
    activeObject.top = tempTop * -1;
    
    activeObject.setCoords();
    activeObject.set("dirty", true);
 
    console.log("dirty Val: " + this.value + ", patternLeftOffset: " + patternLeftOffset + ", patternTopOffset: " + patternTopOffset + ", new left: " + tempLeft + ", new top: " + tempTop);
    console.log("slide2..." + activeObject.scaleX + ", " + activeObject.scaleY + ", " + this.value);
    
    canvasPattern.renderAll();
    
    // DEBUG - outputPattern.innerHTML = this.value + " L:" + activeObject.left + " T:" + activeObject.top + " SX:" + activeObject.scaleX + " SY:" + activeObject.scaleY;
  }
  
  canvasPattern.renderAll();
  
  // OUTLINE SLIDER ------------------------------------------------
  activeObjOutline = getObjectById(canvasPatternOutline, "canvas-pattern-image");
  if(activeObjOutline == null) {
    console.log("could not find active pattern object...");
  }
  else {   
    console.log("slide2...origScaleX: " + originalScaleX + ", origScaleY: " + originalScaleY + ", activeScaleX: " + activeObjOutline.scaleX + ", actScaleY: " + activeObjOutline.scaleY + ", " + this.value);

    factor = (1 + (this.value * .01));
    var scaleX = originalScaleX; //activeObjOutline.scaleX;
    var scaleY = originalScaleY; //activeObjOutline.scaleY;
    var left = 0; //patternLeftOffset * -1; 
    var top = 0; //patternTopOffset * -1; 

    var tempScaleX = scaleX * factor;
    var tempScaleY = scaleY * factor;
    var tempLeft = (625 * factor) - 625;
    var tempTop = (625 * factor) - 625;

    activeObjOutline.scaleX = tempScaleX;
    activeObjOutline.scaleY = tempScaleY;
    activeObjOutline.left = tempLeft * -1;
    activeObjOutline.top = tempTop * -1;

    activeObjOutline.setCoords();
    activeObjOutline.set("dirty", true);

    console.log("Val: " + this.value + ", patternLeftOffset: " + patternLeftOffset + ", patternTopOffset: " + patternTopOffset + ", new:" + (patternLeftOffset - (this.value * 5)));
    console.log("slide2..." + activeObjOutline.scaleX + ", " + activeObjOutline.scaleY + ", " + this.value);
    canvasPatternOutline.renderAll();

    // DEBUG - outputPattern.innerHTML = outputPattern.innerHTML + this.value + " L:" + activeObjOutline.left + " T:" + activeObjOutline.top + " SX:" + activeObjOutline.scaleX + " SY:" + activeObjOutline.scaleY;
  }
  canvasPatternOutline.renderAll();
}

// rotate pattern setup
var rotatePattern = document.getElementById("stikrd-pattern-rotate");
var outputRotatePattern = document.getElementById("pattern-rotate-value");
outputRotatePattern.innerHTML = rotatePattern.value;

rotatePattern.oninput = function() {
  outputRotatePattern.innerHTML = this.value;
  console.log("rotate..." + this.value);

  var activeObj = null;
  var activeObjOutline = null;
  
  activeObject = getObjectById(canvasPattern, "canvas-pattern-image");
  if(activeObject == null) {
    console.log("could not find active pattern object...");
  }
  else {
    // expand / shrink image based on slider
    console.log("rotatezoom..." + activeObject.id + ", " + this.value);
    activeObject.rotate(this.value);    
    activeObject.setCoords();
    canvasPattern.renderAll();
    //outputRotatePattern.innerHTML = this.value; // DEBUG + " L:" + activeObject.left + " T:" + activeObject.top + " SX:" + activeObject.scaleX + " SY:" + activeObject.scaleY;
  }

  // OUTLINE ROTATE
  activeObjOutline = getObjectById(canvasPatternOutline, "canvas-pattern-image");
  if(activeObjOutline == null) {
    console.log("could not find active pattern OUTLINE object...");
  }
  else {
    // expand / shrink image based on slider
    console.log("rotatezoom..." + activeObjOutline.id + ", " + this.value);
    activeObjOutline.rotate(this.value);
    activeObjOutline.setCoords();
    canvasPatternOutline.renderAll();
  }
}

let usedColors = $("#used-colors");
//usedColors.html(welcomeText);

let bdfg = "69!";

// handle used color clicks, add to active color    
const usedColorsWrapper = document.querySelector(".used-colors-container");
usedColorsWrapper.addEventListener("click", (event) => {
  const div = event.target;

  console.log("used color click set active: " + div.id + ", " + div.getAttribute("data-hex"));
  
  updateColors(div.id.replaceAll("-", " "), div.getAttribute("data-hex").replace("#", ""));
});  
  
$('#help-modal').on('show.bs.modal', function (event) {
  var modal = $(this)
  console.log("modal email");
})
  
// #send message for help
$('#help-send-message').click(function (e) {
  console.log("send help message");
  // find active canvas and save svg
  let activeTab = getActiveTab();
  let svg = null;
  if(activeTab == 1) {
    if(isSolid) {
      // save 1    
      try {   
        sendEmailHelp(canvas, true); 
      }
      catch(err) {
        console.log(err.message);
      };      
    }  
    else {
      // save 2
      try {   
        sendEmailHelp(canvasOutline, true); 
      }
      catch(err) {
        console.log(err.message);
      };
    }
  } 
  else if(activeTab == 2) {
    if(isSolid) {
      // save 1
      try {   
        sendEmailHelp(canvasGradient, true); 
      }
      catch(err) {
        console.log(err.message);
      };
    }  
    else {
      // save 2
      try {   
        sendEmailHelp(canvasGradientOutline, true); 
      }
      catch(err) {
        console.log(err.message);
      };
    }
  }
  else if(activeTab == 3) {
    if(isSolid) {
      // save 1
      try {   
        sendEmailHelp(canvasPattern, true); 
      }
      catch(err) {
        console.log(err.message);
      };
    }  
    else {
      // save 2
      try {   
        sendEmailHelp(canvasPatternOutline, true); 
      }
      catch(err) {
        console.log(err.message);
      };
    }
  }
});

  
// #button for help
$('#btn-help').click(function (e) {
    console.log("help modal popup message");
    $('#modal-help').modal('show');
});
  
// #button for help 
$('#btn-help-1').click(function (e) {
    $('#modal-help-1').modal('show');
});
// #button for help
$('#btn-help-2').click(function (e) {
    $('#modal-help-2').modal('show');
});
// #button for help
$('#btn-help-3').click(function (e) {
    $('#modal-help-3').modal('show');
});

  
// send design
function sendEmailHelp(canvas, adjust) {
  console.log("send email test extra prep help:");

  
  
  AWS_S3_Generate_Upload.prepHelp(canvas, adjust);

  
}

  
// send design #sendEmail
function sendEmail(canvas, adjust) {

  $(".overlay").show();

  resetZoom();

  var origWidth = canvas.width;
  var origHeight = canvas.height;
  
  // add a color bar with pantones
  addLegend(canvas);
 
  

   canvas.getObjects().forEach(function (obj) {
if (obj.hasOwnProperty('originalTop')) {
  console.log("original top: " + obj.originalTop);
}     
if (obj.hasOwnProperty('originalLeft')) {
  // Safe to access obj.originalLeft
  console.log("original left: " + obj.originalLeft);
}     
      console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
    });






  if(adjust) {   
    canvas.width = mainWidth;
    canvas.height = mainHeight;
    
    // adjust objects to fit virtual canvas?
    canvas.getObjects().forEach(function (obj) {
if (obj.hasOwnProperty('originalTop')) {
  console.log("original top: " + obj.originalTop);
}     
if (obj.hasOwnProperty('originalLeft')) {
  // Safe to access obj.originalLeft
  console.log("original left: " + obj.originalLeft);
}     
      console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
      
    // skip the background pattern TODO5  
    if(obj.id != "canvas-pattern-image") {  
      obj.left = obj.left + (mainWidth / 2);
      obj.top = obj.top + (mainHeight / 2);
    }
    });
  }

  if(1 == 1) {
  var dataUri = "data:" + "text" + ";base64," + btoa(canvas.toSVG());
  console.log("dataUri: " + dataUri.length);
  Email.send({
        SecureToken : "39a001b8-6f04-43db-8139-9eaea4e1e413",
          To : 'eezdid@gmail.com,orders@stikrd.com',
          From : "stikrddesignstudio@gmail.com",
          Subject : "Design Studio SVG File: " + designId,
          html : "<h1>STIKRD</h1>",
          Body : "<h1>Design Studio File: " + designId + "</h1>",
        Attachments :     [{
            name : "design-" + designId + ".svg",
            data : dataUri //"data:text;base64," + base64
        }]
    }).then( 
        message => { console.log(message)
                    //alert("message?: " + message);
                    
        if(message == "OK") {
          console.log("message OK: " + message);
          $("#product-form").trigger("submit");
        }
        else {
          console.log("message NOT OK: " + message);
          $(".overlay").hide();
          $('#modal-alert').modal('show');
          if(adjust) {   
            canvas.width = origWidth;
            canvas.height = origHeight;
            
            // adjust objects to fit virtual canvas?
            canvas.getObjects().forEach(function (obj) {
              console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
              obj.left = obj.left - (mainWidth / 2);
              obj.top = obj.top - (mainHeight / 2);
            });
          }
        }
      }            
      );   
  }   
}

// upload design
function uploadDesign(canvas, adjust) {

  $(".overlay").show();

  resetZoom();

  var origWidth = canvas.width;
  var origHeight = canvas.height;
  
  // add a color bar with pantones
  addLegend(canvas);
 
  // debug
  canvas.getObjects().forEach(function (obj) {
    if (obj.hasOwnProperty('originalTop')) {
      console.log("original top: " + obj.originalTop);
    }     
    if (obj.hasOwnProperty('originalLeft')) {
      // Safe to access obj.originalLeft
      console.log("original left: " + obj.originalLeft);
    }     
    console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
  });

  if(adjust) {   
    canvas.width = mainWidth;
    canvas.height = mainHeight + 300;
    
    // adjust objects to fit virtual canvas?
    canvas.getObjects().forEach(function (obj) {
      if (obj.hasOwnProperty('originalTop')) {
        console.log("original top: " + obj.originalTop);
      }     
      if (obj.hasOwnProperty('originalLeft')) {
        // Safe to access obj.originalLeft
        console.log("original left: " + obj.originalLeft);
      }     
      console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
              
      // skip the background pattern TODO5  
      if(obj.id != "canvas-pattern-image") {  
        obj.left = obj.left + (mainWidth / 2);
        obj.top = obj.top + (mainHeight / 2);
      }
    });
  }

  AWS_S3_Generate_Upload.prepCart(canvas, adjust);

 //   AWS_S3_Generate_Upload.uploadFile("upload", svgFile);
//
  // SVG
  /*const svgFile = new File(
    [new Blob([canvas.toSVG()], { type: "image/svg+xml" })],
    "design.svg",
    { type: "image/svg+xml" }
  );

  // PNG
  canvas.toBlob(function(blob) {
    const pngFile = new File(
      [blob],
      "design.png",
      { type: "image/png" }
    );

    // upload both using your existing uploadFile(...)
    AWS_S3_Generate_Upload.uploadFile("upload", pngFile);

  });
  */

                    
 
        /*if(message == "OK") {
          console.log("message OK: " + message);
          $("#product-form").trigger("submit");
        }
        else {
          console.log("message NOT OK: " + message);
          $(".overlay").hide();
          $('#modal-alert').modal('show');
          if(adjust) {   
            canvas.width = origWidth;
            canvas.height = origHeight;
            
            // adjust objects to fit virtual canvas?
            canvas.getObjects().forEach(function (obj) {
              console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
              obj.left = obj.left - (mainWidth / 2);
              obj.top = obj.top - (mainHeight / 2);
            });
          }
        }
          */
         
}

// Upload methods for S3
var AWS_S3_Generate_Upload = function () {
    var bucketName = "";
    var s3Service;
    var formatsToConvert;
    var formatConversion;
    var contentTypeConversions;
    var awsTimeoutId;
    var cartTimeoutId;
    var finalDesignUrl = '';
    var proofUrl = '';

    return {
        init: async function (identityPoolId, bucketName) {
           console.log("INIT starting... AWS typeof:", typeof AWS);

            if(typeof AWS !== "undefined") {
                console.log("INIT: bucketName: " + bucketName + ", identityPoolId: " + identityPoolId);
                AWS_S3_Generate_Upload.bucketName = bucketName;
                AWS.config.update({
                    region: 'us-west-1',
                    credentials: new AWS.CognitoIdentityCredentials({
                        IdentityPoolId: identityPoolId
                    })
                });

                AWS_S3_Generate_Upload.s3Service = new AWS.S3({
                    apiVersion: '2006-03-01',
                    params: { Bucket: AWS_S3_Generate_Upload.bucketName }
                });

                AWS_S3_Generate_Upload.formatsToConvert = ".eps,.pdf";
                AWS_S3_Generate_Upload.formatConversion = { "eps": "svg", "pdf": "svg" };
                AWS_S3_Generate_Upload.contentTypeConversions = { "svg": "image/svg+xml" };
                AWS_S3_Generate_Upload.cartTimeoutId = 0;
                AWS_S3_Generate_Upload.awsTimeoutId = 0;

                console.log("INIT: done: " + bucketName + ", identityPoolId: " + identityPoolId);
            }
        },
    // Promise wrapper so prepCart can await
    uploadFileAsync: function (folderName, file, designId) {
      return new Promise((resolve, reject) => {
        AWS_S3_Generate_Upload.uploadFile(folderName, file, designId, (url, err) => {
          if (err) reject(err);
          else resolve(url);
        });
      });
    },

    prepCart: async function (canvas, adjust) {
      let designId = $("#design-id").val();

      const currentdate = new Date();
      const folderName = currentdate.getFullYear() +
        "" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "" +
        currentdate.getDate();
      const uniqueNumber =
        currentdate.getFullYear() +
        "" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "" +
        String(currentdate.getDate()).padStart(2, "0") +
        "" +
        currentdate.getHours() +
        "" +
        currentdate.getMinutes() +
        "" +
        currentdate.getSeconds();

      if(designId.length <= 0)
        designId = uniqueNumber;
      console.log("Prep cart...design id: " + designId);


      // ---- PNG proof ----
      const htmlCanvas = canvas.getElement ? canvas.getElement() : canvas;
      const proofBlob = await new Promise(resolve =>
        htmlCanvas.toBlob(resolve, "image/png")
      );
      const proofFile = new File([proofBlob], designId + "-proof.png", {
        lastModified: Date.now(),
        type: "image/png"
      });

      // ---- SVG final ----
      //{ width: "500", height: "500" }
      const designSvgString = canvas.toSVG();
      const designFile = new File([designSvgString], designId + "-final.svg", {
        lastModified: Date.now(),
        type: "image/svg+xml"
      });

      try {
        // Upload both and wait
        const [finalUrl, proofUrl] = await Promise.all([
          AWS_S3_Generate_Upload.uploadFileAsync(folderName, designFile, designId),
          AWS_S3_Generate_Upload.uploadFileAsync(folderName, proofFile, designId)
        ]);

        console.log("✅ Upload success");
        console.log("Final:", finalUrl);
        console.log("Proof:", proofUrl);

        // success path here (save to cart, submit form, etc.)
        AWS_S3_Generate_Upload.finalDesignUrl = finalUrl;
        AWS_S3_Generate_Upload.proofUrl = proofUrl;

        $("#design-proof").val(proofUrl);
        $("#design-file").val(finalUrl);

        console.log("Uploaded:", { designId, finalUrl, proofUrl });

        $("#product-form").trigger("submit");
        
      } catch (err) {
        console.error("Upload failed", err);

        $(".overlay").hide();
        $('#modal-alert').modal('show');

        if(adjust) {   
          canvas.width = origWidth;
          canvas.height = origHeight;
          
          // adjust objects to fit virtual canvas?
          canvas.getObjects().forEach(function (obj) {
            console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
            obj.left = obj.left - (mainWidth / 2);
            obj.top = obj.top - (mainHeight / 2);
          });
        }

      }      


      AWS_S3_Generate_Upload.cleanupCheck();
      return { designId };
    },
    prepHelp: async function (canvas, adjust) {
      let designId = $("#design-id").val();

      const currentdate = new Date();
      const folderName = currentdate.getFullYear() +
        "" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "" +
        currentdate.getDate();
      const uniqueNumber =
        currentdate.getFullYear() +
        "" +
        String(currentdate.getMonth() + 1).padStart(2, "0") +
        "" +
        String(currentdate.getDate()).padStart(2, "0") +
        "" +
        currentdate.getHours() +
        "" +
        currentdate.getMinutes() +
        "" +
        currentdate.getSeconds();

      if(designId.length <= 0)
        designId = uniqueNumber;
      console.log("Prep cart...w/ Legend design id: " + designId + ", Cwidth: " + canvas.width  + ", Cheight: " + canvas.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);

        resetZoom();

        // add a color bar with pantones
        addLegend(canvas);

        var origWidth = canvas.width;
        var origHeight = canvas.height;

        if(adjust) {   
          canvas.width = mainWidth;
          canvas.height = mainHeight; // + 300;
          
          // adjust objects to fit virtual canvas?
          canvas.getObjects().forEach(function (obj) {
            console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
            if(obj.id != "canvas-pattern-image") {  
              obj.left = obj.left + (mainWidth / 2);
              obj.top = obj.top + (mainHeight / 2);
            }
            //if(obj.id == "canvas-pattern-image") {  

            //}
          });
          //canvas.requestRenderAll();
        }      

      console.log("Prep cart post adjust...w/ Legend design id: " + designId + ", Cwidth: " + canvas.width  + ", Cheight: " + canvas.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);
      // ---- PNG proof ----
      // Trim design to?
      const htmlCanvas = canvas.getElement ? canvas.getElement() : canvas;
      const proofBlob = await new Promise(resolve =>
        htmlCanvas.toBlob(resolve, "image/png")
      );
      const proofFile = new File([proofBlob], designId + "-proof.png", {
        lastModified: Date.now(),
        type: "image/png"
      });

      // ---- SVG final ----
      //{ width: "500", height: "500" }
      const designSvgString = canvas.toSVG();
      const designFile = new File([designSvgString], designId + "-final.svg", {
        lastModified: Date.now(),
        type: "image/svg+xml"
      });

      try {
        // Upload both and wait
        const [finalUrl, proofUrl] = await Promise.all([
          AWS_S3_Generate_Upload.uploadFileAsync(folderName, designFile, designId),
          AWS_S3_Generate_Upload.uploadFileAsync(folderName, proofFile, designId)
        ]);

        console.log("✅ Upload success");
        console.log("Final:", finalUrl);
        console.log("Proof:", proofUrl);

        // success path here (save to cart, submit form, etc.)
        AWS_S3_Generate_Upload.finalDesignUrl = finalUrl;
        AWS_S3_Generate_Upload.proofUrl = proofUrl;

        console.log("Uploaded:", { designId, finalUrl, proofUrl });

       // var body = "<h1>STIKRD</h1><h1>Design Studio File: " + proofUrl + "</h1><br>From: " + emailAddress + "<br>" + $("#help-message-text").val();

        var emailAddress = $("#sender-email").val();
        var userMessage = $("#help-message-text").val();


        const subject = encodeURIComponent("STIKRD Help Request: " + designId);
        const body = encodeURIComponent(`
        Email: ${emailAddress}

        Message:
        ${userMessage}

        Design file:
        Proof PNG file: ${proofUrl}

        `);
        
//        Design SVG: ${finalUrl}

        window.location.href =
          `mailto:orders@stikrd.com,stikrd@matchupsports.com?subject=${subject}&body=${body}`;



        console.log("body: " + body + ", email: " + emailAddress);


        //  To : 'richard@stikrd.com,richard@matchupsports.com',
        //  Subject : "Help Message from Design Studio: " + designId
        //    name : "design-" + designId + ".svg",

        if(adjust) {   
          canvas.width = origWidth;
          canvas.height = origHeight;
          
          // adjust objects to fit virtual canvas?
          canvas.getObjects().forEach(function (obj) {
            console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
            if(obj.id != "canvas-pattern-image") {  
              obj.left = obj.left - (mainWidth / 2);
              obj.top = obj.top - (mainHeight / 2);
            }
          });
        }

        $("#modal-help").modal('hide');        
        
      } catch (err) {
        console.error("Upload failed", err);


        if(adjust) {   
          canvas.width = origWidth;
          canvas.height = origHeight;
          
          // adjust objects to fit virtual canvas?
          canvas.getObjects().forEach(function (obj) {
            console.log("for each obj D2! : " + obj.type + ", id: "+ obj.id + ", originX: " + obj.originX + ", originY: " + obj.originY + ", left: " + obj.left + ", top: " + obj.top + ", width: " + obj.width + ", height: " + obj.height + ", mainW: " + mainWidth + ", mainH: " + mainHeight);    
            obj.left = obj.left - (mainWidth / 2);
            obj.top = obj.top - (mainHeight / 2);
          });
        }

      }      


      AWS_S3_Generate_Upload.cleanupCheck();
      return { designId };
    },    
        getSignedURL(bucketItem){
            var signedUrl = bucketItem;

            var params = {
                Bucket: AWS_S3_Generate_Upload.bucketName,
                Key: encodeURI(bucketItem)
            };

            AWS_S3_Generate_Upload.s3Service.headObject(params, function (err, metadata) {  
                if(err && err.code === 'NotFound') {  
                    AWS_S3_Generate_Upload.printStatus("Bucket item not found for file: " + bucketItem);
                } else {  
                    return AWS_S3_Generate_Upload.s3Service.getSignedUrl('getObject', params); 
                }
            });

            return signedUrl;
        },
        printStatus: function (status) {
            console.log(status);
        },
        uploadFile: function (folderName, file, designId, handleURL) {
            var currentdate = new Date();
            var uniqueNumber = currentdate.getFullYear() + ""
                + (currentdate.getMonth()) + ""
                + currentdate.getDate() + ""
                + currentdate.getHours() + ""
                + currentdate.getMinutes() + ""
                + currentdate.getSeconds();
            var fileName, albumFilesKey, fileKey, fileType;

            if (!file) {
                if (typeof handleURL === "function") handleURL(null, new Error("Invalid file"));
                return;
            }
              AWS_S3_Generate_Upload.printStatus("Upload file #" + ", file name: " + file.name);

            if(file) {
                AWS_S3_Generate_Upload.printStatus("Uploading file #" + " to S3...folder: " + folderName + ", file name: " + file.name + ", file type: " + file.type);

                //var renamedFile = new File([file],  file.name.replace(/ /g, "_"), {type: file.type});
                //file = renamedFile;

                // Use the GENID with the file name (GENID1XXXXXXX-upload), not the user's actual file name (file.name)
                var mime = file.type;
                const m = mime.toLowerCase();
                if (m.startsWith("image/svg+xml")) 
                  fileType = "svg";
                else if (m.startsWith("image/png")) 
                  fileType = "png";
                else
                  fileType = "bin";
                

                //fileName = folderName.length > 0 ? folderName + "-generated" : uniqueNumber;
                //fileName = fileName + "." + fileType;
                fileName = file.name;

                //uploadfileType = file.type;
                uploadfileType = (file.type || "").split(";")[0];
                albumFilesKey = folderName.length > 0 ? folderName + "/" : "";
                fileKey = albumFilesKey + fileName;

                AWS_S3_Generate_Upload.printStatus("Uploading file to S3...uploadfileType: " + uploadfileType + ", albumFilesKey: " + albumFilesKey + ", fileKey: " + fileKey);

                AWS_S3_Generate_Upload.s3Service.upload({
                    Key: fileKey,
                    Body: file,
                    ContentType: uploadfileType,
                    ACL: 'public-read'
                }, function (err, data) {
                    var uploadAWSURL = "error";

                    if(err) {
                        console.log("There was an error uploading your file", err);
                        //$.unblockUI();
                        $(".img-gen-spinner").addClass("d-none");

                        if (typeof handleURL === "function") handleURL(null, err);
                        return;
                    }

                    AWS_S3_Generate_Upload.printStatus('Data: ' + data);

                    if(data != null) {
                        uploadAWSURL = "https://" + AWS_S3_Generate_Upload.bucketName + ".s3.us-west-1.amazonaws.com/" + fileKey;

                        AWS_S3_Generate_Upload.printStatus('File was uploaded successfully to: ' + uploadAWSURL);

                    }
                    else {
                        AWS_S3_Generate_Upload.printStatus("Could not get uploaded file information");
                        
                        //clearInterval(timeoutId);
                        //$.unblockUI();
                        $(".img-gen-spinner").addClass("d-none");
                        AWS_S3_Generate_Upload.printStatus("Final image in uplaod else not null.  No further processing...unblock ui.");
                    }

                    if (typeof handleURL === "function") handleURL(uploadAWSURL, null);
                                        

                });

                AWS_S3_Generate_Upload.printStatus("File upload process to S3 completed with valid file; check previous logs for error or success.");
            } else {
                if(typeof handleURL === "function") {
                    handleURL("error");
                }

                AWS_S3_Generate_Upload.printStatus("Invalid file");

                //clearInterval(timeoutId);
                //$.unblockUI();
                $(".img-gen-spinner").addClass("d-none");
                AWS_S3_Generate_Upload.printStatus("Final image in upload invalid file.  No further processing...unblock ui.");
            }
        },
        cleanupCheck() {
            //clearInterval(timeoutId);
            $(".img-gen-spinner").addClass("d-none");
            //$.unblockUI();

            AWS_S3_Generate_Upload.printStatus("Final image in save: #" + ".  No further processing...clear timeout and unblock ui.");  
        },
    };
}();

$(document).ready(function() {
  const metallicCookie = document.cookie.split('; ').find(row => row.startsWith('metallic='));
  
  // Check if cookie exists and is set to "true"
  if (metallicCookie && metallicCookie.split('=')[1] === 'true') {
    console.log("metallic cookie true");
    hide_metallic_msg = true;
  }
  $("#metallic-checkbox").click(function() {
    console.log("metallic click");
    if ($(this).is(":checked")) {
      document.cookie = "metallic=true; expires=" + new Date(Date.now() + 86400000).toUTCString();
      console.log("checked! metallic click");
      hide_metallic_msg = true;
    } else {
      // Unset cookie
      document.cookie = "metallic=true; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      hide_metallic_msg = false;
    }
  });

  $(document).on('click', '#mockup-proceed', function() {
    doAddToCart();
  });
  
  // #mockup-approval checkbox
  $('#mockup-approval').click(function (e) {
    if($('#mockup-approval').prop("checked") == true) {
      console.log("true");
      $('#mockup-proceed').removeClass("btn-secondary");
      $('#mockup-proceed').addClass("btn-primary");
    }
    else {
      console.log("false");
      $('#mockup-proceed').removeClass("btn-primary");
      $('#mockup-proceed').addClass("btn-secondary");
    }
  });
    
  function doAddToCart() {  
    // check the checkbox warning
    /*if($('#approve-checkbox').prop("checked") == false) {
      console.log("add to cart validation:false");
      // show warning
      $('#notification').show();
      return false;
    }*/
    if($('#mockup-approval').prop("checked") == false) {
      console.log("add to cart acknowledge:false");
      return false;
    }
    else
      $('#modal-acknowledgement').modal('hide');
  
    // TODO: add error handling if email fails and overlay on Add to cart
    
    if(isGloss)
      $("#design-finish").val("Gloss");
    else
      $("#design-finish").val("Matte");
  
    // add note details for 3rd-party
    /*
    if(qs_store.length > 0) {
      console.log("Add note details for Store: " + qs_store);
      $("#custom-engraving").val($("#custom-engraving").val() + "\r\nDesign Id: " + designId);
      $("#design-id").prop("disabled", true);
    }
    */
    
    // find active canvas and save svg
    let activeTab = getActiveTab();
    let svg = null;
    if(activeTab == 1) {
      if(isSolid) {
        $("#design-type").val("Custom Solid Color Swap");
        // save 1    
        try { 
          // update the form element
          updateCustomColors(canvas);
          uploadDesign(canvas, true);       
        }
        catch(err) {
          console.log(err.message);
        };      
      }  
      else {
        $("#design-type").val("Custom Outline Color Swap");
        // save 2
        try {   
          // update the form element
          updateCustomColors(canvasOutline);
          uploadDesign(canvasOutline, true);       
        }
        catch(err) {
          console.log(err.message);
        };
      }
    } 
    else if(activeTab == 2) {
      if(isSolid) {
        $("#design-type").val("Custom Solid Gradient");
        // save 1
        try {   
          // update the form element
          updateCustomColors(canvasGradient);
          uploadDesign(canvasGradient, true);       
        }
        catch(err) {
          console.log(err.message);
        };
      }  
      else {
        $("#design-type").val("Custom Outline Gradient");
        // save 2
        try {   
          // update the form element
          updateCustomColors(canvasGradientOutline);
          uploadDesign(canvasGradientOutline, true);       
        }
        catch(err) {
          console.log(err.message);
        };
      }
    }
    else if(activeTab == 3) {
      if(isSolid) {
        $("#design-type").val("Custom Solid Pattern");
        // save 1
        try {   

          // update the form element
          updateCustomColors(canvasPattern);
          uploadDesign(canvasPattern, true);       
        }
        catch(err) {
          console.log(err.message);
        };
      }  
      else {
        $("#design-type").val("Custom Outline Pattern");
        // save 2
        try {   
          // update the form element
          updateCustomColors(canvasPatternOutline);
          uploadDesign(canvasPatternOutline, true);       
        }
        catch(err) {
          console.log(err.message);
        };
      }
    }
    $('#modal-acknowledgement').modal('hide');
  }

  function clickPatternByName(patternName) {
    // Normalize spaces and case for matching
    patternName = patternName.replace(/\+/g, ' ').trim().toLowerCase();
  
    // Find the div that contains the pattern name text
    const $patternDiv = $(`div[id^='patternName']`).filter(function () {
      return $(this).text().trim().toLowerCase() === patternName;
    });
  
    if ($patternDiv.length) {
      // Click the swatch-pattern div inside the same parent
      $patternDiv.closest('div[style*="display: flex"]').find('.swatch-pattern').trigger('click');
      console.log(`Clicked swatch for: ${patternName}`);
    } else {
      console.log(`Pattern name not found: ${patternName}`);
      $('.swatch-pattern').first().click(); 
    }
  }  

  //clickGradientsByColors
  function clickGradientsByColors(colors) {
      console.log("Colors to set for gradient: " + colors);

      const colorsArray = colors.split(",");

      colorsArray.forEach((hex, index) => {
        const targetHex = hex.trim().toLowerCase();
        console.log("targetHex: " + targetHex + ", index: " + index);

        // Find div with matching data-hex
        const colorDiv = $(`div[data-color-hex="${targetHex}"]`);
        if (colorDiv.length) {
            // Trigger click
            colorDiv.trigger("click");
            console.log("targetHex: " + targetHex + ", index: " + index);

            // After that, click the corresponding gradient-color div
            const gradientDiv = $(`#gradient-color-${index + 1}`);
            if (gradientDiv.length) {
                gradientDiv.trigger("click");
            }            
        };
    });
      
  }

  //clickColorByColor
  function clickColorByColor(color) {

      const cleanHex = color.replace(/^#/, '').toLowerCase();
      console.log("Colors to set for color: " + cleanHex);


      // Find div with matching data-hex
      const colorDiv = $(`div[data-color-hex="${cleanHex}"]`);
      if (colorDiv.length) {
          // Trigger click
          colorDiv.trigger("click");

          // Get active object and iterate on each piece and update
        console.log("Color click, iterate: " + cleanHex);

        // The color name element has an id pattern: "colorName-" + swatch.id
        /////const colorNameEl = document.querySelector(`#colorName-${colorDiv.id}`);
        //if (!colorNameEl) colorName = "";
        const colorNameObj = colorDiv.next('div');

        // Get just the text before the (100%) span
        const colorName = colorNameObj[0].childNodes[0]?.nodeValue?.trim();
        
        updateAllObjectColors(canvas, cleanHex, colorName);        
        updateAllObjectColors(canvasOutline, cleanHex, colorName);        
      };
      
  }

  $(function () {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      newTooltipEl = new bootstrap.Tooltip(tooltipTriggerEl);
      return newTooltipEl;
    })

    //var newTooltip_btn_help_1 = new bootstrap.Tooltip($("#btn-help-1"));
    //newTooltip_btn_help_1.show(1000);
    
    //var newTooltip_brand_colors_button = new bootstrap.Tooltip($("#brand-colors-button"));
    //newTooltip_brand_colors_button.show(1000);
    var newTooltip_pantone_colors_button = new bootstrap.Tooltip($("#pantone-colors-button"));
    var newTooltip_gradient_tab = new bootstrap.Tooltip($("#gradient-tab"));
    var newTooltip_canvas = new bootstrap.Tooltip($("#canvas"));
  if(getUrlParameter('pattern').length <= 0) {

    newTooltip_pantone_colors_button.show(1000);

  
    newTooltip_gradient_tab.show(1000);

    //var newTooltip_solidOutlineSwitch = new bootstrap.Tooltip($("#solidOutlineSwitch"));
    //newTooltip_solidOutlineSwitch.show(1000);

    //var newTooltip_finishSwitch = new bootstrap.Tooltip($("#finishSwitch"));
    //newTooltip_finishSwitch.show(1000);

    newTooltip_canvas.show(1000);
    }
    
    setTimeout(hideTooltips, 10000);  
      
    function hideTooltips() {
      //newTooltip_btn_help_1.hide(2000);
      //newTooltip_brand_colors_button.hide(0);
      newTooltip_pantone_colors_button.hide(0);
      newTooltip_gradient_tab.hide(1000);
      //newTooltip_solidOutlineSwitch.hide(1000);
      //newTooltip_finishSwitch.hide(1000);
      newTooltip_canvas.hide(1000);
       console.log("post process events tooltip : ");
    }

    $(document).on("click", function(event) {
      console.log("Clicked anywhere on the page!", event);      
      // You can access the clicked element using event.target
      if(!waitForMe)
        hideTooltips();
    });

/*
  window.addEventListener("load", function() {
      // Attempt to lock orientation to landscape
      if (screen.orientation && screen.orientation.lock) {
        screen.orientation.lock("landscape").then(function() {
          console.log("Orientation locked to landscape!");
        }).catch(function(error) {
          console.error("Error locking orientation:", error);
        });
      } else {
        console.warn("Screen orientation locking not supported.");
        // Provide a message to the user suggesting landscape mode
      }
    });   
    */

   (function () {
        detectPortrait();
        $(window).resize(function() {
            detectPortrait("#main-div");
        });

        function detectPortrait(mainDiv) {
            console.log("orientation: " + screen.width + ", " + $(document).width());
            if ($(document).width() < 1004 || screen.width < 1004) {
                $("#notification-orientation").show();
            }
            else {
                $("#notification-orientation").hide();
            }
        }
    })();
    
  })  

  // first
  createColorButtons();
  createPatternButtons();
    
  $('[id^="typeButton"]').first().click();

  // second
  // set default color
  $('#' + defaultColor).click(); 
  $('#pantoneHolderMain.swatch').first().click(); 

  $('.swatch-pattern').first().click(); 
  $("#pattern-container").hide();
  $('#patterns-button').click();  
  var content = $('#patterns-button').next()[0];
  console.log("click pattern 2: " + content.style.maxHeight);
  content.style.maxHeight = maxHeightColl + "px";
  console.log("click pattern 2: " + content.style.maxHeight);

  // look for a parameter passed for pattern
  if(getUrlParameter('pattern').length > 0) {
    console.log("pattern override:" + getUrlParameter('pattern'));
    setTimeout(clickPatternByName, 2000, getUrlParameter('pattern'));  
    $("#pattern-tab").click();
    $("#home-tab").removeClass("active");
    $("#pattern-tab").addClass("active");
    $('#patterns-button').click();  

  }
  else if(getUrlParameter('gradient').length > 0) {
    console.log("gradient override:" + getUrlParameter('gradient'));
    setTimeout(clickGradientsByColors, 3000, getUrlParameter('gradient'));  
    $("#gradient-tab").click();
    $("#home-tab").removeClass("active");
    $("#gradient-tab").addClass("active");
    //$('#gradient-button').click();  

  }
  else if(getUrlParameter('color').length > 0) {
    console.log("color override:" + getUrlParameter('color'));
    // delay to allow for the svg's to load on to the canvas
    setTimeout(clickColorByColor, 3000, getUrlParameter('color'));  
  }
  /* else {
    $('.swatch-pattern').first().click(); 
    $("#pattern-container").hide();
    $('#patterns-button').click();  
    var content = $('#patterns-button').next()[0];
    console.log("click pattern 2: " + content.style.maxHeight);
      content.style.maxHeight = maxHeightColl + "px";
    console.log("click pattern 2: " + content.style.maxHeight);
    //$('#patterns-button').css('max-height', '200px');
    //

  } */
  
  // third
  collapseColors($('#pantone-colors-button')[0]);    


  // five
  // tree node logic expand collapse toggle
  var toggler = document.getElementsByClassName("caret");
  var i;
  // tree node click handler
  for (i = 0; i < toggler.length; i++) {
    toggler[i].addEventListener("click", function() {
      this.parentElement.querySelector(".nested").classList.toggle("active");
      this.classList.toggle("caret-down");
    });
  }  


  // Initialize the AWS upload function and change event to perform the upload
  //  AWS_S3_Generate_Upload.init("us-west-1:5fb7170c-74d6-40aa-a200-a9d6c62fa515", "personalization-tool-user-files");

$('#notes-icon').on('click', function () {
  console.log("notes-icon");
  $('#notes-icon').addClass("d-none");
  $('#notes-field').removeClass("d-none");
});

  document.getElementById('zoomOut').addEventListener('click', () => {
    let canvas = getActiveCanvas();

    let zoomLevel = zoomMap.get(canvas);
    console.log("zoom out, zoomLvl: " + zoomLevel + ", minZoom: " + minZoom);
    if (zoomLevel > minZoom) {
      zoomLevel -= zoomStep;
      zoomMap.set(canvas, zoomLevel);
      canvas.setZoom(zoomLevel);
      canvas.setViewportTransform([zoomLevel, 0, 0, zoomLevel, 0, 0]);
      //centerViewport(canvas, zoomLevel);
/*
    let canvasEl = document.getElementById(canvas.id); // Should be an ID
    const container = canvasEl.parentElement; //('div'); //
    if (container) {
        console.log(container.id); // Output: "parent-div"
        console.log(container.tagName); // Output: "DIV"
    }      
    const wrapper = document.getElementById('canvas-wrapper');     // Should be an ID
    const lowerCanvas = container.querySelector('canvas.lower-canvas');
    const upperCanvas = container.querySelector('canvas.upper-canvas');

    const baseWidth = 800;
    const baseHeight = 600;
    const width = baseWidth * zoomLevel;
    const height = baseHeight * zoomLevel;

    // Resize Fabric canvas logic
    canvas.setWidth(width);
    canvas.setHeight(height);

    // Resize DOM styles for both canvas layers and container
    container.style.width = width + 'px';
    container.style.height = height + 'px';

    lowerCanvas.style.width = width + 'px';
    lowerCanvas.style.height = height + 'px';
    lowerCanvas.width = width;
    lowerCanvas.height = height;

    upperCanvas.style.width = width + 'px';
    upperCanvas.style.height = height + 'px';
    upperCanvas.width = width;
    upperCanvas.height = height;
*/
    canvas.renderAll();
    }
  });

  document.getElementById('zoomIn').addEventListener('click', () => {
    let canvas = getActiveCanvas();
    let zoomLevel = zoomMap.get(canvas);

    console.log("zoom IN, zoomLvl: " + zoomLevel + ", maxZoom: " + maxZoom + ", id=" + canvas.id);
    
    if (zoomLevel < maxZoom) {
      zoomLevel += zoomStep;
      zoomMap.set(canvas, zoomLevel);
      canvas.setZoom(zoomLevel);

      canvas.setViewportTransform([zoomLevel, 0, 0, zoomLevel, 0, 0]);

      canvas.renderAll();
    }
  });

  /* document.getElementById('resetZoom').addEventListener('click', () => {
  */
  
  console.log("ZOOM1:" + document.getElementById("zoomIn"));
  
  function centerViewport(canvas, zoomLevel) {
    const vpt = canvas.viewportTransform;
    vpt[4] = (canvas.getWidth() / 2) - (canvas.getWidth() / 2) * zoomLevel;
    vpt[5] = (canvas.getHeight() / 2) - (canvas.getHeight() / 2) * zoomLevel;
    canvas.requestRenderAll();
  }
  
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.matches('[id="PBarNextFrameWrapper"]')) {
          node.style.display = "none";
        }
      });
    });
  });


  AWS_S3_Generate_Upload.init("us-west-1:fe530c45-fb0b-4609-867b-d2245237aeed", "stikrd-user-files");
  console.log("Init s3 here");

});  
  



  } catch(e) { console.error(e); }
})();
})();
